/**
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { _ as _objectWithoutProperties, I as Icon, a as _extends } from '../Icon-83b9d1f1.js';
import '@carbon/icon-helpers';
import 'prop-types';
import React from 'react';

var didWarnAboutDeprecation = {};

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13.71 12.29L7.41 6 13 6 13 4 4 4 4 13 6 13 6 7.41 12.29 13.71 13.71 12.29zM28 30H12a2 2 0 01-2-2V18h2V28H28V12H18V10H28a2 2 0 012 2V28A2 2 0 0128 30z"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22,15H17v2h5v2H18a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V17A2,2,0,0,0,22,15Zm0,8H18V21h4Z"
});

var WatsonHealthPointerText20 = /*#__PURE__*/React.forwardRef(function WatsonHealthPointerText20(_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref2, _ref3, children);
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13.71 12.29L7.41 6 13 6 13 4 4 4 4 13 6 13 6 7.41 12.29 13.71 13.71 12.29zM28 30H12a2 2 0 01-2-2V18h2V28H28V12H18V10H28a2 2 0 012 2V28A2 2 0 0128 30z"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22,15H17v2h5v2H18a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V17A2,2,0,0,0,22,15Zm0,8H18V21h4Z"
});

var WatsonHealthPointerText16 = /*#__PURE__*/React.forwardRef(function WatsonHealthPointerText16(_ref4, ref) {
  var children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref5, _ref6, children);
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 24H12V30H10z"
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21,20H7a3.0033,3.0033,0,0,1-3-3V6H2V17a5.0059,5.0059,0,0,0,5,5H21a4.9419,4.9419,0,0,1,2.105.481L17,28.5859,18.4141,30l6.3071-6.3071A4.96,4.96,0,0,1,26,27v3h2V27A7.0078,7.0078,0,0,0,21,20Z"
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.2746,4.0386l-7-2a1.0013,1.0013,0,0,0-.55,0l-7,2A.9993.9993,0,0,0,10.03,5.2422L11,9.123V11A7,7,0,1,0,25,11V9.123l.97-3.8808A.9993.9993,0,0,0,25.2746,4.0386ZM18,4.04l5.7952,1.6558L23.219,8H19V6H17V8H12.781l-.5762-2.3042ZM18,16a5.0058,5.0058,0,0,1-5-5V10H23v1A5.0058,5.0058,0,0,1,18,16Z"
});

var Police32 = /*#__PURE__*/React.forwardRef(function Police32(_ref7, ref) {
  var children = _ref7.children,
      rest = _objectWithoutProperties(_ref7, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref8, _ref9, _ref10, children);
});

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 24H12V30H10z"
});

var _ref13 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21,20H7a3.0033,3.0033,0,0,1-3-3V6H2V17a5.0059,5.0059,0,0,0,5,5H21a4.9419,4.9419,0,0,1,2.105.481L17,28.5859,18.4141,30l6.3071-6.3071A4.96,4.96,0,0,1,26,27v3h2V27A7.0078,7.0078,0,0,0,21,20Z"
});

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.2746,4.0386l-7-2a1.0013,1.0013,0,0,0-.55,0l-7,2A.9993.9993,0,0,0,10.03,5.2422L11,9.123V11A7,7,0,1,0,25,11V9.123l.97-3.8808A.9993.9993,0,0,0,25.2746,4.0386ZM18,4.04l5.7952,1.6558L23.219,8H19V6H17V8H12.781l-.5762-2.3042ZM18,16a5.0058,5.0058,0,0,1-5-5V10H23v1A5.0058,5.0058,0,0,1,18,16Z"
});

var Police24 = /*#__PURE__*/React.forwardRef(function Police24(_ref11, ref) {
  var children = _ref11.children,
      rest = _objectWithoutProperties(_ref11, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref12, _ref13, _ref14, children);
});

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 24H12V30H10z"
});

var _ref17 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21,20H7a3.0033,3.0033,0,0,1-3-3V6H2V17a5.0059,5.0059,0,0,0,5,5H21a4.9419,4.9419,0,0,1,2.105.481L17,28.5859,18.4141,30l6.3071-6.3071A4.96,4.96,0,0,1,26,27v3h2V27A7.0078,7.0078,0,0,0,21,20Z"
});

var _ref18 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.2746,4.0386l-7-2a1.0013,1.0013,0,0,0-.55,0l-7,2A.9993.9993,0,0,0,10.03,5.2422L11,9.123V11A7,7,0,1,0,25,11V9.123l.97-3.8808A.9993.9993,0,0,0,25.2746,4.0386ZM18,4.04l5.7952,1.6558L23.219,8H19V6H17V8H12.781l-.5762-2.3042ZM18,16a5.0058,5.0058,0,0,1-5-5V10H23v1A5.0058,5.0058,0,0,1,18,16Z"
});

var Police20 = /*#__PURE__*/React.forwardRef(function Police20(_ref15, ref) {
  var children = _ref15.children,
      rest = _objectWithoutProperties(_ref15, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref16, _ref17, _ref18, children);
});

var _ref20 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 24H12V30H10z"
});

var _ref21 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21,20H7a3.0033,3.0033,0,0,1-3-3V6H2V17a5.0059,5.0059,0,0,0,5,5H21a4.9419,4.9419,0,0,1,2.105.481L17,28.5859,18.4141,30l6.3071-6.3071A4.96,4.96,0,0,1,26,27v3h2V27A7.0078,7.0078,0,0,0,21,20Z"
});

var _ref22 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.2746,4.0386l-7-2a1.0013,1.0013,0,0,0-.55,0l-7,2A.9993.9993,0,0,0,10.03,5.2422L11,9.123V11A7,7,0,1,0,25,11V9.123l.97-3.8808A.9993.9993,0,0,0,25.2746,4.0386ZM18,4.04l5.7952,1.6558L23.219,8H19V6H17V8H12.781l-.5762-2.3042ZM18,16a5.0058,5.0058,0,0,1-5-5V10H23v1A5.0058,5.0058,0,0,1,18,16Z"
});

var Police16 = /*#__PURE__*/React.forwardRef(function Police16(_ref19, ref) {
  var children = _ref19.children,
      rest = _objectWithoutProperties(_ref19, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref20, _ref21, _ref22, children);
});

var _ref24 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 18A6 6 0 1020 22.46v7.54l4-1.8926 4 1.8926V22.46A5.98 5.98 0 0030 18zm-4 8.84l-2-.9467L22 26.84V23.65a5.8877 5.8877 0 004 0zM24 22a4 4 0 114-4A4.0045 4.0045 0 0124 22zM9 14H16V16H9zM9 8H19V10H9z"
});

var _ref25 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6,30a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V8H22V4H6V28H16v2Z"
});

var Policy32 = /*#__PURE__*/React.forwardRef(function Policy32(_ref23, ref) {
  var children = _ref23.children,
      rest = _objectWithoutProperties(_ref23, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref24, _ref25, children);
});

var _ref27 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 18A6 6 0 1020 22.46v7.54l4-1.8926 4 1.8926V22.46A5.98 5.98 0 0030 18zm-4 8.84l-2-.9467L22 26.84V23.65a5.8877 5.8877 0 004 0zM24 22a4 4 0 114-4A4.0045 4.0045 0 0124 22zM9 14H16V16H9zM9 8H19V10H9z"
});

var _ref28 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6,30a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V8H22V4H6V28H16v2Z"
});

var Policy24 = /*#__PURE__*/React.forwardRef(function Policy24(_ref26, ref) {
  var children = _ref26.children,
      rest = _objectWithoutProperties(_ref26, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref27, _ref28, children);
});

var _ref30 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 18A6 6 0 1020 22.46v7.54l4-1.8926 4 1.8926V22.46A5.98 5.98 0 0030 18zm-4 8.84l-2-.9467L22 26.84V23.65a5.8877 5.8877 0 004 0zM24 22a4 4 0 114-4A4.0045 4.0045 0 0124 22zM9 14H16V16H9zM9 8H19V10H9z"
});

var _ref31 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6,30a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V8H22V4H6V28H16v2Z"
});

var Policy20 = /*#__PURE__*/React.forwardRef(function Policy20(_ref29, ref) {
  var children = _ref29.children,
      rest = _objectWithoutProperties(_ref29, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref30, _ref31, children);
});

var _ref33 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 18A6 6 0 1020 22.46v7.54l4-1.8926 4 1.8926V22.46A5.98 5.98 0 0030 18zm-4 8.84l-2-.9467L22 26.84V23.65a5.8877 5.8877 0 004 0zM24 22a4 4 0 114-4A4.0045 4.0045 0 0124 22zM9 14H16V16H9zM9 8H19V10H9z"
});

var _ref34 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6,30a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V8H22V4H6V28H16v2Z"
});

var Policy16 = /*#__PURE__*/React.forwardRef(function Policy16(_ref32, ref) {
  var children = _ref32.children,
      rest = _objectWithoutProperties(_ref32, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref33, _ref34, children);
});

var _ref36 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,4H10A2.0059,2.0059,0,0,0,8,6V20a2.0059,2.0059,0,0,0,2,2H28a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,28,4Zm0,16H10V6H28Z"
});

var _ref37 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18,26H4V16H6V14H4a2.0059,2.0059,0,0,0-2,2V26a2.0059,2.0059,0,0,0,2,2H18a2.0059,2.0059,0,0,0,2-2V24H18Z"
});

var Popup32 = /*#__PURE__*/React.forwardRef(function Popup32(_ref35, ref) {
  var children = _ref35.children,
      rest = _objectWithoutProperties(_ref35, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref36, _ref37, children);
});

var _ref39 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,4H10A2.0059,2.0059,0,0,0,8,6V20a2.0059,2.0059,0,0,0,2,2H28a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,28,4Zm0,16H10V6H28Z"
});

var _ref40 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18,26H4V16H6V14H4a2.0059,2.0059,0,0,0-2,2V26a2.0059,2.0059,0,0,0,2,2H18a2.0059,2.0059,0,0,0,2-2V24H18Z"
});

var Popup24 = /*#__PURE__*/React.forwardRef(function Popup24(_ref38, ref) {
  var children = _ref38.children,
      rest = _objectWithoutProperties(_ref38, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref39, _ref40, children);
});

var _ref42 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,4H10A2.0059,2.0059,0,0,0,8,6V20a2.0059,2.0059,0,0,0,2,2H28a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,28,4Zm0,16H10V6H28Z"
});

var _ref43 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18,26H4V16H6V14H4a2.0059,2.0059,0,0,0-2,2V26a2.0059,2.0059,0,0,0,2,2H18a2.0059,2.0059,0,0,0,2-2V24H18Z"
});

var Popup20 = /*#__PURE__*/React.forwardRef(function Popup20(_ref41, ref) {
  var children = _ref41.children,
      rest = _objectWithoutProperties(_ref41, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref42, _ref43, children);
});

var _ref45 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,4H10A2.0059,2.0059,0,0,0,8,6V20a2.0059,2.0059,0,0,0,2,2H28a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,28,4Zm0,16H10V6H28Z"
});

var _ref46 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18,26H4V16H6V14H4a2.0059,2.0059,0,0,0-2,2V26a2.0059,2.0059,0,0,0,2,2H18a2.0059,2.0059,0,0,0,2-2V24H18Z"
});

var Popup16 = /*#__PURE__*/React.forwardRef(function Popup16(_ref44, ref) {
  var children = _ref44.children,
      rest = _objectWithoutProperties(_ref44, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref45, _ref46, children);
});

var _ref48 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,10H22V6a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,6h8v4H12ZM4,26V12H28V26Z"
});

var Portfolio32 = /*#__PURE__*/React.forwardRef(function Portfolio32(_ref47, ref) {
  var children = _ref47.children,
      rest = _objectWithoutProperties(_ref47, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref48, children);
});

var _ref50 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,10H22V6a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,6h8v4H12ZM4,26V12H28V26Z"
});

var Portfolio24 = /*#__PURE__*/React.forwardRef(function Portfolio24(_ref49, ref) {
  var children = _ref49.children,
      rest = _objectWithoutProperties(_ref49, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref50, children);
});

var _ref52 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,10H22V6a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,6h8v4H12ZM4,26V12H28V26Z"
});

var Portfolio20 = /*#__PURE__*/React.forwardRef(function Portfolio20(_ref51, ref) {
  var children = _ref51.children,
      rest = _objectWithoutProperties(_ref51, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref52, children);
});

var _ref54 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,10H22V6a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,6h8v4H12ZM4,26V12H28V26Z"
});

var Portfolio16 = /*#__PURE__*/React.forwardRef(function Portfolio16(_ref53, ref) {
  var children = _ref53.children,
      rest = _objectWithoutProperties(_ref53, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref54, children);
});

var _ref56 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22.5,5.74l-1,1.73a11,11,0,1,1-11,0l-1-1.73a13,13,0,1,0,13,0Z"
});

var _ref57 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2H17V16H15z"
});

var Power32 = /*#__PURE__*/React.forwardRef(function Power32(_ref55, ref) {
  var children = _ref55.children,
      rest = _objectWithoutProperties(_ref55, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref56, _ref57, children);
});

var _ref59 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22.5,5.74l-1,1.73a11,11,0,1,1-11,0l-1-1.73a13,13,0,1,0,13,0Z"
});

var _ref60 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2H17V16H15z"
});

var Power24 = /*#__PURE__*/React.forwardRef(function Power24(_ref58, ref) {
  var children = _ref58.children,
      rest = _objectWithoutProperties(_ref58, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref59, _ref60, children);
});

var _ref62 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22.5,5.74l-1,1.73a11,11,0,1,1-11,0l-1-1.73a13,13,0,1,0,13,0Z"
});

var _ref63 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2H17V16H15z"
});

var Power20 = /*#__PURE__*/React.forwardRef(function Power20(_ref61, ref) {
  var children = _ref61.children,
      rest = _objectWithoutProperties(_ref61, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref62, _ref63, children);
});

var _ref65 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.2,2.9l-0.5,0.9c2.6,1.5,3.5,4.9,2,7.5s-4.9,3.5-7.5,2s-3.5-4.9-2-7.5c0.5-0.8,1.2-1.5,2-2L4.8,2.9\tc-3.1,1.8-4.2,5.8-2.4,8.9s5.8,4.2,8.9,2.4s4.2-5.8,2.4-8.9C13.1,4.3,12.2,3.4,11.2,2.9z"
});

var _ref66 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.5 1H8.5V8H7.5z"
});

var Power16 = /*#__PURE__*/React.forwardRef(function Power16(_ref64, ref) {
  var children = _ref64.children,
      rest = _objectWithoutProperties(_ref64, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref65, _ref66, children);
});

var _ref68 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 11L25 11 25 23 27 23 27 11 30 11 30 9 22 9 22 11zM14 23H12V9h6a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H14zm0-7h4V10.9985H14zM4 23H2V9H8a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H4zm0-7H8V10.9985H4z"
});

var Ppt32 = /*#__PURE__*/React.forwardRef(function Ppt32(_ref67, ref) {
  var children = _ref67.children,
      rest = _objectWithoutProperties(_ref67, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref68, children);
});

var _ref70 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 11L25 11 25 23 27 23 27 11 30 11 30 9 22 9 22 11zM14 23H12V9h6a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H14zm0-7h4V10.9985H14zM4 23H2V9H8a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H4zm0-7H8V10.9985H4z"
});

var Ppt24 = /*#__PURE__*/React.forwardRef(function Ppt24(_ref69, ref) {
  var children = _ref69.children,
      rest = _objectWithoutProperties(_ref69, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref70, children);
});

var _ref72 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 11L25 11 25 23 27 23 27 11 30 11 30 9 22 9 22 11zM14 23H12V9h6a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H14zm0-7h4V10.9985H14zM4 23H2V9H8a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H4zm0-7H8V10.9985H4z"
});

var Ppt20 = /*#__PURE__*/React.forwardRef(function Ppt20(_ref71, ref) {
  var children = _ref71.children,
      rest = _objectWithoutProperties(_ref71, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref72, children);
});

var _ref74 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 11L25 11 25 23 27 23 27 11 30 11 30 9 22 9 22 11zM14 23H12V9h6a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H14zm0-7h4V10.9985H14zM4 23H2V9H8a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H4zm0-7H8V10.9985H4z"
});

var Ppt16 = /*#__PURE__*/React.forwardRef(function Ppt16(_ref73, ref) {
  var children = _ref73.children,
      rest = _objectWithoutProperties(_ref73, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref74, children);
});

var _ref76 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 10H17V18H15zM20 14H22V18H20zM10 12H12V18H10z"
});

var _ref77 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,4H17V2H15V4H7A2,2,0,0,0,5,6V20a2,2,0,0,0,2,2h8v6H11v2H21V28H17V22h8a2,2,0,0,0,2-2V6A2,2,0,0,0,25,4Zm0,16H7V6H25Z"
});

var PresentationFile32 = /*#__PURE__*/React.forwardRef(function PresentationFile32(_ref75, ref) {
  var children = _ref75.children,
      rest = _objectWithoutProperties(_ref75, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref76, _ref77, children);
});

var _ref79 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 10H17V18H15zM20 14H22V18H20zM10 12H12V18H10z"
});

var _ref80 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,4H17V2H15V4H7A2,2,0,0,0,5,6V20a2,2,0,0,0,2,2h8v6H11v2H21V28H17V22h8a2,2,0,0,0,2-2V6A2,2,0,0,0,25,4Zm0,16H7V6H25Z"
});

var PresentationFile24 = /*#__PURE__*/React.forwardRef(function PresentationFile24(_ref78, ref) {
  var children = _ref78.children,
      rest = _objectWithoutProperties(_ref78, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref79, _ref80, children);
});

var _ref82 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 10H17V18H15zM20 14H22V18H20zM10 12H12V18H10z"
});

var _ref83 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,4H17V2H15V4H7A2,2,0,0,0,5,6V20a2,2,0,0,0,2,2h8v6H11v2H21V28H17V22h8a2,2,0,0,0,2-2V6A2,2,0,0,0,25,4Zm0,16H7V6H25Z"
});

var PresentationFile20 = /*#__PURE__*/React.forwardRef(function PresentationFile20(_ref81, ref) {
  var children = _ref81.children,
      rest = _objectWithoutProperties(_ref81, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref82, _ref83, children);
});

var _ref85 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 10H17V18H15zM20 14H22V18H20zM10 12H12V18H10z"
});

var _ref86 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,4H17V2H15V4H7A2,2,0,0,0,5,6V20a2,2,0,0,0,2,2h8v6H11v2H21V28H17V22h8a2,2,0,0,0,2-2V6A2,2,0,0,0,25,4Zm0,16H7V6H25Z"
});

var PresentationFile16 = /*#__PURE__*/React.forwardRef(function PresentationFile16(_ref84, ref) {
  var children = _ref84.children,
      rest = _objectWithoutProperties(_ref84, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref85, _ref86, children);
});

var _ref88 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.5053,16l8.1591-7.2529A1,1,0,0,0,25,7H22V2H20V9h2.37L16,14.6621,9.63,9H12V2H10V7H7a1,1,0,0,0-.6646,1.7471L14.4945,16,6.3353,23.2529A1,1,0,0,0,7,25h3v5h2V23H9.63L16,17.3379,22.37,23H20v7h2V25h3a1,1,0,0,0,.6645-1.7471Z"
});

var Pressure32 = /*#__PURE__*/React.forwardRef(function Pressure32(_ref87, ref) {
  var children = _ref87.children,
      rest = _objectWithoutProperties(_ref87, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref88, children);
});

var _ref90 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.5053,16l8.1591-7.2529A1,1,0,0,0,25,7H22V2H20V9h2.37L16,14.6621,9.63,9H12V2H10V7H7a1,1,0,0,0-.6646,1.7471L14.4945,16,6.3353,23.2529A1,1,0,0,0,7,25h3v5h2V23H9.63L16,17.3379,22.37,23H20v7h2V25h3a1,1,0,0,0,.6645-1.7471Z"
});

var Pressure24 = /*#__PURE__*/React.forwardRef(function Pressure24(_ref89, ref) {
  var children = _ref89.children,
      rest = _objectWithoutProperties(_ref89, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref90, children);
});

var _ref92 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.5053,16l8.1591-7.2529A1,1,0,0,0,25,7H22V2H20V9h2.37L16,14.6621,9.63,9H12V2H10V7H7a1,1,0,0,0-.6646,1.7471L14.4945,16,6.3353,23.2529A1,1,0,0,0,7,25h3v5h2V23H9.63L16,17.3379,22.37,23H20v7h2V25h3a1,1,0,0,0,.6645-1.7471Z"
});

var Pressure20 = /*#__PURE__*/React.forwardRef(function Pressure20(_ref91, ref) {
  var children = _ref91.children,
      rest = _objectWithoutProperties(_ref91, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref92, children);
});

var _ref94 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.5053,16l8.1591-7.2529A1,1,0,0,0,25,7H22V2H20V9h2.37L16,14.6621,9.63,9H12V2H10V7H7a1,1,0,0,0-.6646,1.7471L14.4945,16,6.3353,23.2529A1,1,0,0,0,7,25h3v5h2V23H9.63L16,17.3379,22.37,23H20v7h2V25h3a1,1,0,0,0,.6645-1.7471Z"
});

var Pressure16 = /*#__PURE__*/React.forwardRef(function Pressure16(_ref93, ref) {
  var children = _ref93.children,
      rest = _objectWithoutProperties(_ref93, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref94, children);
});

var _ref96 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 30H10V25H6l10-9 10 9H22zM16 16L6 7h4V2H22V7h4z"
});

var PressureFilled32 = /*#__PURE__*/React.forwardRef(function PressureFilled32(_ref95, ref) {
  var children = _ref95.children,
      rest = _objectWithoutProperties(_ref95, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref96, children);
});

var _ref98 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 30H10V25H6l10-9 10 9H22zM16 16L6 7h4V2H22V7h4z"
});

var PressureFilled24 = /*#__PURE__*/React.forwardRef(function PressureFilled24(_ref97, ref) {
  var children = _ref97.children,
      rest = _objectWithoutProperties(_ref97, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref98, children);
});

var _ref100 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 30H10V25H6l10-9 10 9H22zM16 16L6 7h4V2H22V7h4z"
});

var PressureFilled20 = /*#__PURE__*/React.forwardRef(function PressureFilled20(_ref99, ref) {
  var children = _ref99.children,
      rest = _objectWithoutProperties(_ref99, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref100, children);
});

var _ref102 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 30H10V25H6l10-9 10 9H22zM16 16L6 7h4V2H22V7h4z"
});

var PressureFilled16 = /*#__PURE__*/React.forwardRef(function PressureFilled16(_ref101, ref) {
  var children = _ref101.children,
      rest = _objectWithoutProperties(_ref101, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref102, children);
});

var _ref104 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm8,15H11.85l5.58,5.5728L16,24,8,16l8-8,1.43,1.3926L11.85,15H24Z"
});

var _ref105 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z",
  "data-icon-path": "inner-path"
});

var PreviousFilled32 = /*#__PURE__*/React.forwardRef(function PreviousFilled32(_ref103, ref) {
  var children = _ref103.children,
      rest = _objectWithoutProperties(_ref103, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref104, _ref105, children);
});

var _ref107 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm8,15H11.85l5.58,5.5728L16,24,8,16l8-8,1.43,1.3926L11.85,15H24Z"
});

var _ref108 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z",
  "data-icon-path": "inner-path"
});

var PreviousFilled24 = /*#__PURE__*/React.forwardRef(function PreviousFilled24(_ref106, ref) {
  var children = _ref106.children,
      rest = _objectWithoutProperties(_ref106, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref107, _ref108, children);
});

var _ref110 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm8,15H11.85l5.58,5.5728L16,24,8,16l8-8,1.43,1.3926L11.85,15H24Z"
});

var _ref111 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z",
  "data-icon-path": "inner-path"
});

var PreviousFilled20 = /*#__PURE__*/React.forwardRef(function PreviousFilled20(_ref109, ref) {
  var children = _ref109.children,
      rest = _objectWithoutProperties(_ref109, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref110, _ref111, children);
});

var _ref113 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm8,15H11.85l5.58,5.5728L16,24,8,16l8-8,1.43,1.3926L11.85,15H24Z"
});

var _ref114 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z",
  "data-icon-path": "inner-path"
});

var PreviousFilled16 = /*#__PURE__*/React.forwardRef(function PreviousFilled16(_ref112, ref) {
  var children = _ref112.children,
      rest = _objectWithoutProperties(_ref112, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref113, _ref114, children);
});

var _ref116 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z"
});

var _ref117 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
});

var PreviousOutline32 = /*#__PURE__*/React.forwardRef(function PreviousOutline32(_ref115, ref) {
  var children = _ref115.children,
      rest = _objectWithoutProperties(_ref115, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref116, _ref117, children);
});

var _ref119 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z"
});

var _ref120 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
});

var PreviousOutline24 = /*#__PURE__*/React.forwardRef(function PreviousOutline24(_ref118, ref) {
  var children = _ref118.children,
      rest = _objectWithoutProperties(_ref118, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref119, _ref120, children);
});

var _ref122 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z"
});

var _ref123 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
});

var PreviousOutline20 = /*#__PURE__*/React.forwardRef(function PreviousOutline20(_ref121, ref) {
  var children = _ref121.children,
      rest = _objectWithoutProperties(_ref121, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref122, _ref123, children);
});

var _ref125 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z"
});

var _ref126 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
});

var PreviousOutline16 = /*#__PURE__*/React.forwardRef(function PreviousOutline16(_ref124, ref) {
  var children = _ref124.children,
      rest = _objectWithoutProperties(_ref124, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref125, _ref126, children);
});

var _ref128 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,9H25V3H7V9H4a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2H7v6H25V23h3a2,2,0,0,0,2-2V11A2,2,0,0,0,28,9ZM9,5H23V9H9ZM23,27H9V17H23Zm5-6H25V15H7v6H4V11H28Z"
});

var Printer32 = /*#__PURE__*/React.forwardRef(function Printer32(_ref127, ref) {
  var children = _ref127.children,
      rest = _objectWithoutProperties(_ref127, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref128, children);
});

var _ref130 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,9H25V3H7V9H4a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2H7v6H25V23h3a2,2,0,0,0,2-2V11A2,2,0,0,0,28,9ZM9,5H23V9H9ZM23,27H9V17H23Zm5-6H25V15H7v6H4V11H28Z"
});

var Printer24 = /*#__PURE__*/React.forwardRef(function Printer24(_ref129, ref) {
  var children = _ref129.children,
      rest = _objectWithoutProperties(_ref129, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref130, children);
});

var _ref132 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,9H25V3H7V9H4a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2H7v6H25V23h3a2,2,0,0,0,2-2V11A2,2,0,0,0,28,9ZM9,5H23V9H9ZM23,27H9V17H23Zm5-6H25V15H7v6H4V11H28Z"
});

var Printer20 = /*#__PURE__*/React.forwardRef(function Printer20(_ref131, ref) {
  var children = _ref131.children,
      rest = _objectWithoutProperties(_ref131, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref132, children);
});

var _ref134 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,9H25V3H7V9H4a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2H7v6H25V23h3a2,2,0,0,0,2-2V11A2,2,0,0,0,28,9ZM9,5H23V9H9ZM23,27H9V17H23Zm5-6H25V15H7v6H4V11H28Z"
});

var Printer16 = /*#__PURE__*/React.forwardRef(function Printer16(_ref133, ref) {
  var children = _ref133.children,
      rest = _objectWithoutProperties(_ref133, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref134, children);
});

var _ref136 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 18H14V20H8zM8 22H18V24H8z"
});

var _ref137 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM18,6v4H14V6ZM6,26V6h6v6h8V6h6l.0012,20Z"
});

var Product32 = /*#__PURE__*/React.forwardRef(function Product32(_ref135, ref) {
  var children = _ref135.children,
      rest = _objectWithoutProperties(_ref135, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref136, _ref137, children);
});

var _ref139 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 18H14V20H8zM8 22H18V24H8z"
});

var _ref140 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM18,6v4H14V6ZM6,26V6h6v6h8V6h6l.0012,20Z"
});

var Product24 = /*#__PURE__*/React.forwardRef(function Product24(_ref138, ref) {
  var children = _ref138.children,
      rest = _objectWithoutProperties(_ref138, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref139, _ref140, children);
});

var _ref142 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 18H14V20H8zM8 22H18V24H8z"
});

var _ref143 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM18,6v4H14V6ZM6,26V6h6v6h8V6h6l.0012,20Z"
});

var Product20 = /*#__PURE__*/React.forwardRef(function Product20(_ref141, ref) {
  var children = _ref141.children,
      rest = _objectWithoutProperties(_ref141, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref142, _ref143, children);
});

var _ref145 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 18H14V20H8zM8 22H18V24H8z"
});

var _ref146 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM18,6v4H14V6ZM6,26V6h6v6h8V6h6l.0012,20Z"
});

var Product16 = /*#__PURE__*/React.forwardRef(function Product16(_ref144, ref) {
  var children = _ref144.children,
      rest = _objectWithoutProperties(_ref144, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref145, _ref146, children);
});

var _ref148 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6Zm0,2v3H4V8ZM4,24V13H28V24Z"
});

var _ref149 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 20H16V22H6z"
});

var Purchase32 = /*#__PURE__*/React.forwardRef(function Purchase32(_ref147, ref) {
  var children = _ref147.children,
      rest = _objectWithoutProperties(_ref147, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref148, _ref149, children);
});

var _ref151 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6Zm0,2v3H4V8ZM4,24V13H28V24Z"
});

var _ref152 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 20H16V22H6z"
});

var Purchase24 = /*#__PURE__*/React.forwardRef(function Purchase24(_ref150, ref) {
  var children = _ref150.children,
      rest = _objectWithoutProperties(_ref150, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref151, _ref152, children);
});

var _ref154 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6Zm0,2v3H4V8ZM4,24V13H28V24Z"
});

var _ref155 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 20H16V22H6z"
});

var Purchase20 = /*#__PURE__*/React.forwardRef(function Purchase20(_ref153, ref) {
  var children = _ref153.children,
      rest = _objectWithoutProperties(_ref153, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref154, _ref155, children);
});

var _ref157 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6Zm0,2v3H4V8ZM4,24V13H28V24Z"
});

var _ref158 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 20H16V22H6z"
});

var Purchase16 = /*#__PURE__*/React.forwardRef(function Purchase16(_ref156, ref) {
  var children = _ref156.children,
      rest = _objectWithoutProperties(_ref156, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref157, _ref158, children);
});

var _ref160 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "20",
  cy: "4",
  r: "2"
});

var _ref161 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "8",
  cy: "16",
  r: "2"
});

var _ref162 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "28",
  cy: "12",
  r: "2"
});

var _ref163 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "11",
  cy: "7",
  r: "2"
});

var _ref164 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "24",
  r: "2"
});

var _ref165 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,3.4131,28.5859,2,4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4131Z"
});

var QqPlot32 = /*#__PURE__*/React.forwardRef(function QqPlot32(_ref159, ref) {
  var children = _ref159.children,
      rest = _objectWithoutProperties(_ref159, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, children);
});

var _ref167 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "20",
  cy: "4",
  r: "2"
});

var _ref168 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "8",
  cy: "16",
  r: "2"
});

var _ref169 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "28",
  cy: "12",
  r: "2"
});

var _ref170 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "11",
  cy: "7",
  r: "2"
});

var _ref171 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "24",
  r: "2"
});

var _ref172 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,3.4131,28.5859,2,4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4131Z"
});

var QqPlot24 = /*#__PURE__*/React.forwardRef(function QqPlot24(_ref166, ref) {
  var children = _ref166.children,
      rest = _objectWithoutProperties(_ref166, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, children);
});

var _ref174 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "20",
  cy: "4",
  r: "2"
});

var _ref175 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "8",
  cy: "16",
  r: "2"
});

var _ref176 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "28",
  cy: "12",
  r: "2"
});

var _ref177 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "11",
  cy: "7",
  r: "2"
});

var _ref178 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "24",
  r: "2"
});

var _ref179 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,3.4131,28.5859,2,4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4131Z"
});

var QqPlot20 = /*#__PURE__*/React.forwardRef(function QqPlot20(_ref173, ref) {
  var children = _ref173.children,
      rest = _objectWithoutProperties(_ref173, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, children);
});

var _ref181 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "20",
  cy: "4",
  r: "2"
});

var _ref182 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "8",
  cy: "16",
  r: "2"
});

var _ref183 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "28",
  cy: "12",
  r: "2"
});

var _ref184 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "11",
  cy: "7",
  r: "2"
});

var _ref185 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "24",
  r: "2"
});

var _ref186 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,3.4131,28.5859,2,4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4131Z"
});

var QqPlot16 = /*#__PURE__*/React.forwardRef(function QqPlot16(_ref180, ref) {
  var children = _ref180.children,
      rest = _objectWithoutProperties(_ref180, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, children);
});

var _ref188 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 26H26V28H24z",
  transform: "rotate(-90 25 27)"
});

var _ref189 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 22H20V24H18z",
  transform: "rotate(-90 19 23)"
});

var _ref190 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 30L22 30 22 28 20 28 20 26 18 26 18 30z"
});

var _ref191 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 23H29V25H25z",
  transform: "rotate(-90 27 24)"
});

var _ref192 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 26L30 26 30 30 26 30 26 28 28 28 28 26zM26 20L26 18 30 18 30 22 28 22 28 20 26 20zM24 20L22 20 22 24 20 24 20 26 24 26 24 20z"
});

var _ref193 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19 17H21V21H19z",
  transform: "rotate(-90 20 19)"
});

var _ref194 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 22H10V26H6z"
});

var _ref195 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 30H2V18H14zM4 28h8V20H4zM22 6H26V10H22z"
});

var _ref196 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 14H18V2H30zM20 12h8V4H20zM6 6H10V10H6z"
});

var _ref197 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,14H2V2H14ZM4,12h8V4H4Z"
});

var QrCode32 = /*#__PURE__*/React.forwardRef(function QrCode32(_ref187, ref) {
  var children = _ref187.children,
      rest = _objectWithoutProperties(_ref187, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, children);
});

var _ref199 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 26H26V28H24z",
  transform: "rotate(-90 25 27)"
});

var _ref200 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 22H20V24H18z",
  transform: "rotate(-90 19 23)"
});

var _ref201 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 30L22 30 22 28 20 28 20 26 18 26 18 30z"
});

var _ref202 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 23H29V25H25z",
  transform: "rotate(-90 27 24)"
});

var _ref203 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 26L30 26 30 30 26 30 26 28 28 28 28 26zM26 20L26 18 30 18 30 22 28 22 28 20 26 20zM24 20L22 20 22 24 20 24 20 26 24 26 24 20z"
});

var _ref204 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19 17H21V21H19z",
  transform: "rotate(-90 20 19)"
});

var _ref205 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 22H10V26H6z"
});

var _ref206 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 30H2V18H14zM4 28h8V20H4zM22 6H26V10H22z"
});

var _ref207 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 14H18V2H30zM20 12h8V4H20zM6 6H10V10H6z"
});

var _ref208 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,14H2V2H14ZM4,12h8V4H4Z"
});

var QrCode24 = /*#__PURE__*/React.forwardRef(function QrCode24(_ref198, ref) {
  var children = _ref198.children,
      rest = _objectWithoutProperties(_ref198, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, children);
});

var _ref210 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 26H26V28H24z",
  transform: "rotate(-90 25 27)"
});

var _ref211 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 22H20V24H18z",
  transform: "rotate(-90 19 23)"
});

var _ref212 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 30L22 30 22 28 20 28 20 26 18 26 18 30z"
});

var _ref213 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 23H29V25H25z",
  transform: "rotate(-90 27 24)"
});

var _ref214 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 26L30 26 30 30 26 30 26 28 28 28 28 26zM26 20L26 18 30 18 30 22 28 22 28 20 26 20zM24 20L22 20 22 24 20 24 20 26 24 26 24 20z"
});

var _ref215 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19 17H21V21H19z",
  transform: "rotate(-90 20 19)"
});

var _ref216 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 22H10V26H6z"
});

var _ref217 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 30H2V18H14zM4 28h8V20H4zM22 6H26V10H22z"
});

var _ref218 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 14H18V2H30zM20 12h8V4H20zM6 6H10V10H6z"
});

var _ref219 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,14H2V2H14ZM4,12h8V4H4Z"
});

var QrCode20 = /*#__PURE__*/React.forwardRef(function QrCode20(_ref209, ref) {
  var children = _ref209.children,
      rest = _objectWithoutProperties(_ref209, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref210, _ref211, _ref212, _ref213, _ref214, _ref215, _ref216, _ref217, _ref218, _ref219, children);
});

var _ref221 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 26H26V28H24z",
  transform: "rotate(-90 25 27)"
});

var _ref222 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 22H20V24H18z",
  transform: "rotate(-90 19 23)"
});

var _ref223 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 30L22 30 22 28 20 28 20 26 18 26 18 30z"
});

var _ref224 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 23H29V25H25z",
  transform: "rotate(-90 27 24)"
});

var _ref225 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 26L30 26 30 30 26 30 26 28 28 28 28 26zM26 20L26 18 30 18 30 22 28 22 28 20 26 20zM24 20L22 20 22 24 20 24 20 26 24 26 24 20z"
});

var _ref226 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19 17H21V21H19z",
  transform: "rotate(-90 20 19)"
});

var _ref227 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 22H10V26H6z"
});

var _ref228 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 30H2V18H14zM4 28h8V20H4zM22 6H26V10H22z"
});

var _ref229 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 14H18V2H30zM20 12h8V4H20zM6 6H10V10H6z"
});

var _ref230 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,14H2V2H14ZM4,12h8V4H4Z"
});

var QrCode16 = /*#__PURE__*/React.forwardRef(function QrCode16(_ref220, ref) {
  var children = _ref220.children,
      rest = _objectWithoutProperties(_ref220, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref221, _ref222, _ref223, _ref224, _ref225, _ref226, _ref227, _ref228, _ref229, _ref230, children);
});

var _ref232 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 6H28V8H10zM10 12H28V14H10zM15 18H28V20H15zM10 24H28V26H10zM4 14L11 19 4 24 4 14z"
});

var QueryQueue32 = /*#__PURE__*/React.forwardRef(function QueryQueue32(_ref231, ref) {
  var children = _ref231.children,
      rest = _objectWithoutProperties(_ref231, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref232, children);
});

var _ref234 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 6H28V8H10zM10 12H28V14H10zM15 18H28V20H15zM10 24H28V26H10zM4 14L11 19 4 24 4 14z"
});

var QueryQueue24 = /*#__PURE__*/React.forwardRef(function QueryQueue24(_ref233, ref) {
  var children = _ref233.children,
      rest = _objectWithoutProperties(_ref233, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref234, children);
});

var _ref236 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 6H28V8H10zM10 12H28V14H10zM15 18H28V20H15zM10 24H28V26H10zM4 14L11 19 4 24 4 14z"
});

var QueryQueue20 = /*#__PURE__*/React.forwardRef(function QueryQueue20(_ref235, ref) {
  var children = _ref235.children,
      rest = _objectWithoutProperties(_ref235, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref236, children);
});

var _ref238 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 6H28V8H10zM10 12H28V14H10zM15 18H28V20H15zM10 24H28V26H10zM4 14L11 19 4 24 4 14z"
});

var QueryQueue16 = /*#__PURE__*/React.forwardRef(function QueryQueue16(_ref237, ref) {
  var children = _ref237.children,
      rest = _objectWithoutProperties(_ref237, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref238, children);
});

var _ref240 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 20H30V22H22zM22 24H30V26H22zM22 28H30V30H22zM18 24H20V26H18zM18 20H20V22H18zM18 28H20V30H18zM6.8149 8.293A12.0777 12.0777 0 0110.0068 5.62L9.0079 3.89A14.0845 14.0845 0 005.2841 7.0083zM25.1851 8.293l1.5308-1.2847A14.0845 14.0845 0 0022.9921 3.89l-.9989 1.73A12.0777 12.0777 0 0125.1851 8.293zM4.7366 11.9l-1.8772-.6831A13.9019 13.9019 0 002 16H4A11.917 11.917 0 014.7366 11.9zM6.8149 23.707A11.9975 11.9975 0 014.7366 20.1l-1.8772.6831a13.99 13.99 0 002.4247 4.209zM27.2634 11.9A11.917 11.917 0 0128 16h2a13.8971 13.8971 0 00-.8594-4.7827zM13.9182 27.8066A11.8894 11.8894 0 0110.0068 26.38l-.9989 1.73a13.8673 13.8673 0 004.5633 1.664zM13.9182 4.1934a11.3012 11.3012 0 014.1636 0l.347-1.9678a13.187 13.187 0 00-4.8576 0z"
});

var Queued32 = /*#__PURE__*/React.forwardRef(function Queued32(_ref239, ref) {
  var children = _ref239.children,
      rest = _objectWithoutProperties(_ref239, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref240, children);
});

var _ref242 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 20H30V22H22zM22 24H30V26H22zM22 28H30V30H22zM18 24H20V26H18zM18 20H20V22H18zM18 28H20V30H18zM6.8149 8.293A12.0777 12.0777 0 0110.0068 5.62L9.0079 3.89A14.0845 14.0845 0 005.2841 7.0083zM25.1851 8.293l1.5308-1.2847A14.0845 14.0845 0 0022.9921 3.89l-.9989 1.73A12.0777 12.0777 0 0125.1851 8.293zM4.7366 11.9l-1.8772-.6831A13.9019 13.9019 0 002 16H4A11.917 11.917 0 014.7366 11.9zM6.8149 23.707A11.9975 11.9975 0 014.7366 20.1l-1.8772.6831a13.99 13.99 0 002.4247 4.209zM27.2634 11.9A11.917 11.917 0 0128 16h2a13.8971 13.8971 0 00-.8594-4.7827zM13.9182 27.8066A11.8894 11.8894 0 0110.0068 26.38l-.9989 1.73a13.8673 13.8673 0 004.5633 1.664zM13.9182 4.1934a11.3012 11.3012 0 014.1636 0l.347-1.9678a13.187 13.187 0 00-4.8576 0z"
});

var Queued24 = /*#__PURE__*/React.forwardRef(function Queued24(_ref241, ref) {
  var children = _ref241.children,
      rest = _objectWithoutProperties(_ref241, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref242, children);
});

var _ref244 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 20H30V22H22zM22 24H30V26H22zM22 28H30V30H22zM18 24H20V26H18zM18 20H20V22H18zM18 28H20V30H18zM6.8149 8.293A12.0777 12.0777 0 0110.0068 5.62L9.0079 3.89A14.0845 14.0845 0 005.2841 7.0083zM25.1851 8.293l1.5308-1.2847A14.0845 14.0845 0 0022.9921 3.89l-.9989 1.73A12.0777 12.0777 0 0125.1851 8.293zM4.7366 11.9l-1.8772-.6831A13.9019 13.9019 0 002 16H4A11.917 11.917 0 014.7366 11.9zM6.8149 23.707A11.9975 11.9975 0 014.7366 20.1l-1.8772.6831a13.99 13.99 0 002.4247 4.209zM27.2634 11.9A11.917 11.917 0 0128 16h2a13.8971 13.8971 0 00-.8594-4.7827zM13.9182 27.8066A11.8894 11.8894 0 0110.0068 26.38l-.9989 1.73a13.8673 13.8673 0 004.5633 1.664zM13.9182 4.1934a11.3012 11.3012 0 014.1636 0l.347-1.9678a13.187 13.187 0 00-4.8576 0z"
});

var Queued20 = /*#__PURE__*/React.forwardRef(function Queued20(_ref243, ref) {
  var children = _ref243.children,
      rest = _objectWithoutProperties(_ref243, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref244, children);
});

var _ref246 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 20H30V22H22zM22 24H30V26H22zM22 28H30V30H22zM18 24H20V26H18zM18 20H20V22H18zM18 28H20V30H18zM6.8149 8.293A12.0777 12.0777 0 0110.0068 5.62L9.0079 3.89A14.0845 14.0845 0 005.2841 7.0083zM25.1851 8.293l1.5308-1.2847A14.0845 14.0845 0 0022.9921 3.89l-.9989 1.73A12.0777 12.0777 0 0125.1851 8.293zM4.7366 11.9l-1.8772-.6831A13.9019 13.9019 0 002 16H4A11.917 11.917 0 014.7366 11.9zM6.8149 23.707A11.9975 11.9975 0 014.7366 20.1l-1.8772.6831a13.99 13.99 0 002.4247 4.209zM27.2634 11.9A11.917 11.917 0 0128 16h2a13.8971 13.8971 0 00-.8594-4.7827zM13.9182 27.8066A11.8894 11.8894 0 0110.0068 26.38l-.9989 1.73a13.8673 13.8673 0 004.5633 1.664zM13.9182 4.1934a11.3012 11.3012 0 014.1636 0l.347-1.9678a13.187 13.187 0 00-4.8576 0z"
});

var Queued16 = /*#__PURE__*/React.forwardRef(function Queued16(_ref245, ref) {
  var children = _ref245.children,
      rest = _objectWithoutProperties(_ref245, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref246, children);
});

var _ref248 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 15H6.11A9 9 0 0110 8.86l1.79-1.2L10.69 6 8.9 7.2A11 11 0 004 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0012 15zM26 15H20.11A9 9 0 0124 8.86l1.79-1.2L24.7 6 22.9 7.2A11 11 0 0018 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0026 15z"
});

var Quotes32 = /*#__PURE__*/React.forwardRef(function Quotes32(_ref247, ref) {
  var children = _ref247.children,
      rest = _objectWithoutProperties(_ref247, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref248, children);
});

var _ref250 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 15H6.11A9 9 0 0110 8.86l1.79-1.2L10.69 6 8.9 7.2A11 11 0 004 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0012 15zM26 15H20.11A9 9 0 0124 8.86l1.79-1.2L24.7 6 22.9 7.2A11 11 0 0018 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0026 15z"
});

var Quotes24 = /*#__PURE__*/React.forwardRef(function Quotes24(_ref249, ref) {
  var children = _ref249.children,
      rest = _objectWithoutProperties(_ref249, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref250, children);
});

var _ref252 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 15H6.11A9 9 0 0110 8.86l1.79-1.2L10.69 6 8.9 7.2A11 11 0 004 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0012 15zM26 15H20.11A9 9 0 0124 8.86l1.79-1.2L24.7 6 22.9 7.2A11 11 0 0018 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0026 15z"
});

var Quotes20 = /*#__PURE__*/React.forwardRef(function Quotes20(_ref251, ref) {
  var children = _ref251.children,
      rest = _objectWithoutProperties(_ref251, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref252, children);
});

var _ref254 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 15H6.11A9 9 0 0110 8.86l1.79-1.2L10.69 6 8.9 7.2A11 11 0 004 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0012 15zM26 15H20.11A9 9 0 0124 8.86l1.79-1.2L24.7 6 22.9 7.2A11 11 0 0018 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0026 15z"
});

var Quotes16 = /*#__PURE__*/React.forwardRef(function Quotes16(_ref253, ref) {
  var children = _ref253.children,
      rest = _objectWithoutProperties(_ref253, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref254, children);
});

var _ref256 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,10H24V2H22v8H13V8H11v2H8V8H6v2H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,28V12H28V28Z"
});

var _ref257 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 26a4 4 0 114-4A4 4 0 0110 26zm0-6a2 2 0 102 2A2 2 0 0010 20zM7 14H13V16H7zM17 16H26V18H17zM17 20H26V22H17zM17 24H26V26H17z"
});

var Radio32 = /*#__PURE__*/React.forwardRef(function Radio32(_ref255, ref) {
  var children = _ref255.children,
      rest = _objectWithoutProperties(_ref255, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref256, _ref257, children);
});

var _ref259 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,10H24V2H22v8H13V8H11v2H8V8H6v2H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,28V12H28V28Z"
});

var _ref260 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 26a4 4 0 114-4A4 4 0 0110 26zm0-6a2 2 0 102 2A2 2 0 0010 20zM7 14H13V16H7zM17 16H26V18H17zM17 20H26V22H17zM17 24H26V26H17z"
});

var Radio24 = /*#__PURE__*/React.forwardRef(function Radio24(_ref258, ref) {
  var children = _ref258.children,
      rest = _objectWithoutProperties(_ref258, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref259, _ref260, children);
});

var _ref262 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,10H24V2H22v8H13V8H11v2H8V8H6v2H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,28V12H28V28Z"
});

var _ref263 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 26a4 4 0 114-4A4 4 0 0110 26zm0-6a2 2 0 102 2A2 2 0 0010 20zM7 14H13V16H7zM17 16H26V18H17zM17 20H26V22H17zM17 24H26V26H17z"
});

var Radio20 = /*#__PURE__*/React.forwardRef(function Radio20(_ref261, ref) {
  var children = _ref261.children,
      rest = _objectWithoutProperties(_ref261, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref262, _ref263, children);
});

var _ref265 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,10H24V2H22v8H13V8H11v2H8V8H6v2H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,28V12H28V28Z"
});

var _ref266 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 26a4 4 0 114-4A4 4 0 0110 26zm0-6a2 2 0 102 2A2 2 0 0010 20zM7 14H13V16H7zM17 16H26V18H17zM17 20H26V22H17zM17 24H26V26H17z"
});

var Radio16 = /*#__PURE__*/React.forwardRef(function Radio16(_ref264, ref) {
  var children = _ref264.children,
      rest = _objectWithoutProperties(_ref264, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref265, _ref266, children);
});

var _ref268 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
});

var RadioButton32 = /*#__PURE__*/React.forwardRef(function RadioButton32(_ref267, ref) {
  var children = _ref267.children,
      rest = _objectWithoutProperties(_ref267, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref268, children);
});

var _ref270 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
});

var RadioButton24 = /*#__PURE__*/React.forwardRef(function RadioButton24(_ref269, ref) {
  var children = _ref269.children,
      rest = _objectWithoutProperties(_ref269, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref270, children);
});

var _ref272 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
});

var RadioButton20 = /*#__PURE__*/React.forwardRef(function RadioButton20(_ref271, ref) {
  var children = _ref271.children,
      rest = _objectWithoutProperties(_ref271, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref272, children);
});

var _ref274 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
});

var RadioButton16 = /*#__PURE__*/React.forwardRef(function RadioButton16(_ref273, ref) {
  var children = _ref273.children,
      rest = _objectWithoutProperties(_ref273, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref274, children);
});

var _ref276 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
});

var _ref277 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Z"
});

var RadioButtonChecked32 = /*#__PURE__*/React.forwardRef(function RadioButtonChecked32(_ref275, ref) {
  var children = _ref275.children,
      rest = _objectWithoutProperties(_ref275, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref276, _ref277, children);
});

var _ref279 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
});

var _ref280 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Z"
});

var RadioButtonChecked24 = /*#__PURE__*/React.forwardRef(function RadioButtonChecked24(_ref278, ref) {
  var children = _ref278.children,
      rest = _objectWithoutProperties(_ref278, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref279, _ref280, children);
});

var _ref282 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
});

var _ref283 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Z"
});

var RadioButtonChecked20 = /*#__PURE__*/React.forwardRef(function RadioButtonChecked20(_ref281, ref) {
  var children = _ref281.children,
      rest = _objectWithoutProperties(_ref281, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref282, _ref283, children);
});

var _ref285 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
});

var _ref286 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Z"
});

var RadioButtonChecked16 = /*#__PURE__*/React.forwardRef(function RadioButtonChecked16(_ref284, ref) {
  var children = _ref284.children,
      rest = _objectWithoutProperties(_ref284, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref285, _ref286, children);
});

var _ref288 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
});

var Rain32 = /*#__PURE__*/React.forwardRef(function Rain32(_ref287, ref) {
  var children = _ref287.children,
      rest = _objectWithoutProperties(_ref287, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref288, children);
});

var _ref290 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
});

var Rain24 = /*#__PURE__*/React.forwardRef(function Rain24(_ref289, ref) {
  var children = _ref289.children,
      rest = _objectWithoutProperties(_ref289, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref290, children);
});

var _ref292 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
});

var Rain20 = /*#__PURE__*/React.forwardRef(function Rain20(_ref291, ref) {
  var children = _ref291.children,
      rest = _objectWithoutProperties(_ref291, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref292, children);
});

var _ref294 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
});

var Rain16 = /*#__PURE__*/React.forwardRef(function Rain16(_ref293, ref) {
  var children = _ref293.children,
      rest = _objectWithoutProperties(_ref293, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref294, children);
});

var _ref296 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11,30a1,1,0,0,1-.8944-1.4474l2-4a1,1,0,1,1,1.7887.8946l-2,4A.9979.9979,0,0,1,11,30Z"
});

var _ref297 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4973,6.4973,0,0,0,8.5,22H19.3813L18.105,24.5527a1,1,0,0,0,1.789.8946L21.6177,22H23.5A6.4974,6.4974,0,0,0,24.8008,9.1362ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
});

var RainDrizzle32 = /*#__PURE__*/React.forwardRef(function RainDrizzle32(_ref295, ref) {
  var children = _ref295.children,
      rest = _objectWithoutProperties(_ref295, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref296, _ref297, children);
});

var _ref299 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11,30a1,1,0,0,1-.8944-1.4474l2-4a1,1,0,1,1,1.7887.8946l-2,4A.9979.9979,0,0,1,11,30Z"
});

var _ref300 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4973,6.4973,0,0,0,8.5,22H19.3813L18.105,24.5527a1,1,0,0,0,1.789.8946L21.6177,22H23.5A6.4974,6.4974,0,0,0,24.8008,9.1362ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
});

var RainDrizzle24 = /*#__PURE__*/React.forwardRef(function RainDrizzle24(_ref298, ref) {
  var children = _ref298.children,
      rest = _objectWithoutProperties(_ref298, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref299, _ref300, children);
});

var _ref302 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11,30a1,1,0,0,1-.8944-1.4474l2-4a1,1,0,1,1,1.7887.8946l-2,4A.9979.9979,0,0,1,11,30Z"
});

var _ref303 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4973,6.4973,0,0,0,8.5,22H19.3813L18.105,24.5527a1,1,0,0,0,1.789.8946L21.6177,22H23.5A6.4974,6.4974,0,0,0,24.8008,9.1362ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
});

var RainDrizzle20 = /*#__PURE__*/React.forwardRef(function RainDrizzle20(_ref301, ref) {
  var children = _ref301.children,
      rest = _objectWithoutProperties(_ref301, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref302, _ref303, children);
});

var _ref305 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11,30a1,1,0,0,1-.8944-1.4474l2-4a1,1,0,1,1,1.7887.8946l-2,4A.9979.9979,0,0,1,11,30Z"
});

var _ref306 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4973,6.4973,0,0,0,8.5,22H19.3813L18.105,24.5527a1,1,0,0,0,1.789.8946L21.6177,22H23.5A6.4974,6.4974,0,0,0,24.8008,9.1362ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
});

var RainDrizzle16 = /*#__PURE__*/React.forwardRef(function RainDrizzle16(_ref304, ref) {
  var children = _ref304.children,
      rest = _objectWithoutProperties(_ref304, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref305, _ref306, children);
});

var _ref308 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0117 30zM8 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 018 30z"
});

var _ref309 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,15.5a6.5323,6.5323,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0A6.4905,6.4905,0,0,0,5.7026,21.3584L4.106,24.5527a1,1,0,1,0,1.7885.8946L7.6174,22l6.7644,0L13.106,24.5527a1,1,0,1,0,1.7885.8946L16.6177,22h6.7641L22.106,24.5527a1,1,0,1,0,1.7885.8946l1.9444-3.89A6.5058,6.5058,0,0,0,30,15.5ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
});

var RainHeavy32 = /*#__PURE__*/React.forwardRef(function RainHeavy32(_ref307, ref) {
  var children = _ref307.children,
      rest = _objectWithoutProperties(_ref307, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref308, _ref309, children);
});

var _ref311 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0117 30zM8 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 018 30z"
});

var _ref312 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,15.5a6.5323,6.5323,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0A6.4905,6.4905,0,0,0,5.7026,21.3584L4.106,24.5527a1,1,0,1,0,1.7885.8946L7.6174,22l6.7644,0L13.106,24.5527a1,1,0,1,0,1.7885.8946L16.6177,22h6.7641L22.106,24.5527a1,1,0,1,0,1.7885.8946l1.9444-3.89A6.5058,6.5058,0,0,0,30,15.5ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
});

var RainHeavy24 = /*#__PURE__*/React.forwardRef(function RainHeavy24(_ref310, ref) {
  var children = _ref310.children,
      rest = _objectWithoutProperties(_ref310, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref311, _ref312, children);
});

var _ref314 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0117 30zM8 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 018 30z"
});

var _ref315 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,15.5a6.5323,6.5323,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0A6.4905,6.4905,0,0,0,5.7026,21.3584L4.106,24.5527a1,1,0,1,0,1.7885.8946L7.6174,22l6.7644,0L13.106,24.5527a1,1,0,1,0,1.7885.8946L16.6177,22h6.7641L22.106,24.5527a1,1,0,1,0,1.7885.8946l1.9444-3.89A6.5058,6.5058,0,0,0,30,15.5ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
});

var RainHeavy20 = /*#__PURE__*/React.forwardRef(function RainHeavy20(_ref313, ref) {
  var children = _ref313.children,
      rest = _objectWithoutProperties(_ref313, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref314, _ref315, children);
});

var _ref317 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0117 30zM8 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 018 30z"
});

var _ref318 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,15.5a6.5323,6.5323,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0A6.4905,6.4905,0,0,0,5.7026,21.3584L4.106,24.5527a1,1,0,1,0,1.7885.8946L7.6174,22l6.7644,0L13.106,24.5527a1,1,0,1,0,1.7885.8946L16.6177,22h6.7641L22.106,24.5527a1,1,0,1,0,1.7885.8946l1.9444-3.89A6.5058,6.5058,0,0,0,30,15.5ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
});

var RainHeavy16 = /*#__PURE__*/React.forwardRef(function RainHeavy16(_ref316, ref) {
  var children = _ref316.children,
      rest = _objectWithoutProperties(_ref316, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref317, _ref318, children);
});

var _ref320 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.5084,32a1.0127,1.0127,0,0,1-.4485-.1054.9986.9986,0,0,1-.4486-1.3418l1.4934-3.0005a1.0025,1.0025,0,0,1,1.7943.8945l-1.4934,3A1.0013,1.0013,0,0,1,8.5084,32Z"
});

var _ref321 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.232 15.733H29.232V18.733H27.232z",
  transform: "rotate(-45.009 28.232 17.233)"
});

var _ref322 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29 10H32V12H29z"
});

var _ref323 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26.732 3.768H29.732V5.768H26.732z",
  transform: "rotate(-45 28.232 4.768)"
});

var _ref324 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 0H22V3H20z"
});

var _ref325 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12.768 3.268H14.768V6.268H12.768z",
  transform: "rotate(-45 13.768 4.768)"
});

var _ref326 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25h7.3818L14.106,27.5527a1,1,0,1,0,1.7885.8946L17.6177,25H19a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11ZM19,23H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23Zm3.9268-8.5107a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z"
});

var RainScattered32 = /*#__PURE__*/React.forwardRef(function RainScattered32(_ref319, ref) {
  var children = _ref319.children,
      rest = _objectWithoutProperties(_ref319, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref320, _ref321, _ref322, _ref323, _ref324, _ref325, _ref326, children);
});

var _ref328 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.5084,32a1.0127,1.0127,0,0,1-.4485-.1054.9986.9986,0,0,1-.4486-1.3418l1.4934-3.0005a1.0025,1.0025,0,0,1,1.7943.8945l-1.4934,3A1.0013,1.0013,0,0,1,8.5084,32Z"
});

var _ref329 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.232 15.733H29.232V18.733H27.232z",
  transform: "rotate(-45.009 28.232 17.233)"
});

var _ref330 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29 10H32V12H29z"
});

var _ref331 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26.732 3.768H29.732V5.768H26.732z",
  transform: "rotate(-45 28.232 4.768)"
});

var _ref332 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 0H22V3H20z"
});

var _ref333 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12.768 3.268H14.768V6.268H12.768z",
  transform: "rotate(-45 13.768 4.768)"
});

var _ref334 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25h7.3818L14.106,27.5527a1,1,0,1,0,1.7885.8946L17.6177,25H19a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11ZM19,23H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23Zm3.9268-8.5107a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z"
});

var RainScattered24 = /*#__PURE__*/React.forwardRef(function RainScattered24(_ref327, ref) {
  var children = _ref327.children,
      rest = _objectWithoutProperties(_ref327, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref328, _ref329, _ref330, _ref331, _ref332, _ref333, _ref334, children);
});

var _ref336 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.5084,32a1.0127,1.0127,0,0,1-.4485-.1054.9986.9986,0,0,1-.4486-1.3418l1.4934-3.0005a1.0025,1.0025,0,0,1,1.7943.8945l-1.4934,3A1.0013,1.0013,0,0,1,8.5084,32Z"
});

var _ref337 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.232 15.733H29.232V18.733H27.232z",
  transform: "rotate(-45.009 28.232 17.233)"
});

var _ref338 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29 10H32V12H29z"
});

var _ref339 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26.732 3.768H29.732V5.768H26.732z",
  transform: "rotate(-45 28.232 4.768)"
});

var _ref340 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 0H22V3H20z"
});

var _ref341 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12.768 3.268H14.768V6.268H12.768z",
  transform: "rotate(-45 13.768 4.768)"
});

var _ref342 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25h7.3818L14.106,27.5527a1,1,0,1,0,1.7885.8946L17.6177,25H19a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11ZM19,23H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23Zm3.9268-8.5107a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z"
});

var RainScattered20 = /*#__PURE__*/React.forwardRef(function RainScattered20(_ref335, ref) {
  var children = _ref335.children,
      rest = _objectWithoutProperties(_ref335, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref336, _ref337, _ref338, _ref339, _ref340, _ref341, _ref342, children);
});

var _ref344 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.5084,32a1.0127,1.0127,0,0,1-.4485-.1054.9986.9986,0,0,1-.4486-1.3418l1.4934-3.0005a1.0025,1.0025,0,0,1,1.7943.8945l-1.4934,3A1.0013,1.0013,0,0,1,8.5084,32Z"
});

var _ref345 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.232 15.733H29.232V18.733H27.232z",
  transform: "rotate(-45.009 28.232 17.233)"
});

var _ref346 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29 10H32V12H29z"
});

var _ref347 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26.732 3.768H29.732V5.768H26.732z",
  transform: "rotate(-45 28.232 4.768)"
});

var _ref348 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 0H22V3H20z"
});

var _ref349 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12.768 3.268H14.768V6.268H12.768z",
  transform: "rotate(-45 13.768 4.768)"
});

var _ref350 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25h7.3818L14.106,27.5527a1,1,0,1,0,1.7885.8946L17.6177,25H19a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11ZM19,23H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23Zm3.9268-8.5107a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z"
});

var RainScattered16 = /*#__PURE__*/React.forwardRef(function RainScattered16(_ref343, ref) {
  var children = _ref343.children,
      rest = _objectWithoutProperties(_ref343, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref344, _ref345, _ref346, _ref347, _ref348, _ref349, _ref350, children);
});

var _ref352 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.5084 32a1.0115 1.0115 0 01-.4485-.1055.9986.9986 0 01-.4486-1.3418l1.4934-3a1.0025 1.0025 0 011.7943.8945l-1.4934 3A1.0015 1.0015 0 018.5084 32zM29.8442 13.0347a1.5184 1.5184 0 00-1.2309-.8658 5.3587 5.3587 0 01-3.4094-1.7163 6.4648 6.4648 0 01-1.285-6.393 1.6031 1.6031 0 00-.3-1.5459 1.4535 1.4535 0 00-1.3594-.4922l-.0191.0029a7.8549 7.8549 0 00-6.1054 6.48A7.3725 7.3725 0 0013.5 8a7.5511 7.5511 0 00-7.1494 5.2441A5.9926 5.9926 0 008 25h7.3818L14.106 27.5527a1 1 0 101.7885.8946L17.6177 25H19a5.9549 5.9549 0 005.88-7.1455 7.5 7.5 0 004.8672-3.3A1.5381 1.5381 0 0029.8442 13.0347zM19 23H8a3.9926 3.9926 0 01-.6733-7.9292l.663-.1128.1456-.6562a5.496 5.496 0 0110.7294 0l.1456.6562.6626.1128A3.9925 3.9925 0 0119 23zm5.1509-7.0479a5.9639 5.9639 0 00-3.5015-2.708A7.5076 7.5076 0 0018.0286 9.55a6.01 6.01 0 013.77-5.334 8.4581 8.4581 0 001.9395 7.5972A7.4007 7.4007 0 0027.64 14.041 5.4392 5.4392 0 0124.1509 15.9521z"
});

var RainScatteredNight32 = /*#__PURE__*/React.forwardRef(function RainScatteredNight32(_ref351, ref) {
  var children = _ref351.children,
      rest = _objectWithoutProperties(_ref351, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref352, children);
});

var _ref354 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.5084 32a1.0115 1.0115 0 01-.4485-.1055.9986.9986 0 01-.4486-1.3418l1.4934-3a1.0025 1.0025 0 011.7943.8945l-1.4934 3A1.0015 1.0015 0 018.5084 32zM29.8442 13.0347a1.5184 1.5184 0 00-1.2309-.8658 5.3587 5.3587 0 01-3.4094-1.7163 6.4648 6.4648 0 01-1.285-6.393 1.6031 1.6031 0 00-.3-1.5459 1.4535 1.4535 0 00-1.3594-.4922l-.0191.0029a7.8549 7.8549 0 00-6.1054 6.48A7.3725 7.3725 0 0013.5 8a7.5511 7.5511 0 00-7.1494 5.2441A5.9926 5.9926 0 008 25h7.3818L14.106 27.5527a1 1 0 101.7885.8946L17.6177 25H19a5.9549 5.9549 0 005.88-7.1455 7.5 7.5 0 004.8672-3.3A1.5381 1.5381 0 0029.8442 13.0347zM19 23H8a3.9926 3.9926 0 01-.6733-7.9292l.663-.1128.1456-.6562a5.496 5.496 0 0110.7294 0l.1456.6562.6626.1128A3.9925 3.9925 0 0119 23zm5.1509-7.0479a5.9639 5.9639 0 00-3.5015-2.708A7.5076 7.5076 0 0018.0286 9.55a6.01 6.01 0 013.77-5.334 8.4581 8.4581 0 001.9395 7.5972A7.4007 7.4007 0 0027.64 14.041 5.4392 5.4392 0 0124.1509 15.9521z"
});

var RainScatteredNight24 = /*#__PURE__*/React.forwardRef(function RainScatteredNight24(_ref353, ref) {
  var children = _ref353.children,
      rest = _objectWithoutProperties(_ref353, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref354, children);
});

var _ref356 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.5084 32a1.0115 1.0115 0 01-.4485-.1055.9986.9986 0 01-.4486-1.3418l1.4934-3a1.0025 1.0025 0 011.7943.8945l-1.4934 3A1.0015 1.0015 0 018.5084 32zM29.8442 13.0347a1.5184 1.5184 0 00-1.2309-.8658 5.3587 5.3587 0 01-3.4094-1.7163 6.4648 6.4648 0 01-1.285-6.393 1.6031 1.6031 0 00-.3-1.5459 1.4535 1.4535 0 00-1.3594-.4922l-.0191.0029a7.8549 7.8549 0 00-6.1054 6.48A7.3725 7.3725 0 0013.5 8a7.5511 7.5511 0 00-7.1494 5.2441A5.9926 5.9926 0 008 25h7.3818L14.106 27.5527a1 1 0 101.7885.8946L17.6177 25H19a5.9549 5.9549 0 005.88-7.1455 7.5 7.5 0 004.8672-3.3A1.5381 1.5381 0 0029.8442 13.0347zM19 23H8a3.9926 3.9926 0 01-.6733-7.9292l.663-.1128.1456-.6562a5.496 5.496 0 0110.7294 0l.1456.6562.6626.1128A3.9925 3.9925 0 0119 23zm5.1509-7.0479a5.9639 5.9639 0 00-3.5015-2.708A7.5076 7.5076 0 0018.0286 9.55a6.01 6.01 0 013.77-5.334 8.4581 8.4581 0 001.9395 7.5972A7.4007 7.4007 0 0027.64 14.041 5.4392 5.4392 0 0124.1509 15.9521z"
});

var RainScatteredNight20 = /*#__PURE__*/React.forwardRef(function RainScatteredNight20(_ref355, ref) {
  var children = _ref355.children,
      rest = _objectWithoutProperties(_ref355, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref356, children);
});

var _ref358 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.5084 32a1.0115 1.0115 0 01-.4485-.1055.9986.9986 0 01-.4486-1.3418l1.4934-3a1.0025 1.0025 0 011.7943.8945l-1.4934 3A1.0015 1.0015 0 018.5084 32zM29.8442 13.0347a1.5184 1.5184 0 00-1.2309-.8658 5.3587 5.3587 0 01-3.4094-1.7163 6.4648 6.4648 0 01-1.285-6.393 1.6031 1.6031 0 00-.3-1.5459 1.4535 1.4535 0 00-1.3594-.4922l-.0191.0029a7.8549 7.8549 0 00-6.1054 6.48A7.3725 7.3725 0 0013.5 8a7.5511 7.5511 0 00-7.1494 5.2441A5.9926 5.9926 0 008 25h7.3818L14.106 27.5527a1 1 0 101.7885.8946L17.6177 25H19a5.9549 5.9549 0 005.88-7.1455 7.5 7.5 0 004.8672-3.3A1.5381 1.5381 0 0029.8442 13.0347zM19 23H8a3.9926 3.9926 0 01-.6733-7.9292l.663-.1128.1456-.6562a5.496 5.496 0 0110.7294 0l.1456.6562.6626.1128A3.9925 3.9925 0 0119 23zm5.1509-7.0479a5.9639 5.9639 0 00-3.5015-2.708A7.5076 7.5076 0 0018.0286 9.55a6.01 6.01 0 013.77-5.334 8.4581 8.4581 0 001.9395 7.5972A7.4007 7.4007 0 0027.64 14.041 5.4392 5.4392 0 0124.1509 15.9521z"
});

var RainScatteredNight16 = /*#__PURE__*/React.forwardRef(function RainScatteredNight16(_ref357, ref) {
  var children = _ref357.children,
      rest = _objectWithoutProperties(_ref357, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref358, children);
});

var _ref360 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,24V22a3.2965,3.2965,0,0,0,3-3h2A5.2668,5.2668,0,0,1,16,24Z"
});

var _ref361 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z"
});

var RainDrop32 = /*#__PURE__*/React.forwardRef(function RainDrop32(_ref359, ref) {
  var children = _ref359.children,
      rest = _objectWithoutProperties(_ref359, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref360, _ref361, children);
});

var _ref363 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,24V22a3.2965,3.2965,0,0,0,3-3h2A5.2668,5.2668,0,0,1,16,24Z"
});

var _ref364 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z"
});

var RainDrop24 = /*#__PURE__*/React.forwardRef(function RainDrop24(_ref362, ref) {
  var children = _ref362.children,
      rest = _objectWithoutProperties(_ref362, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref363, _ref364, children);
});

var _ref366 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,24V22a3.2965,3.2965,0,0,0,3-3h2A5.2668,5.2668,0,0,1,16,24Z"
});

var _ref367 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z"
});

var RainDrop20 = /*#__PURE__*/React.forwardRef(function RainDrop20(_ref365, ref) {
  var children = _ref365.children,
      rest = _objectWithoutProperties(_ref365, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref366, _ref367, children);
});

var _ref369 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,24V22a3.2965,3.2965,0,0,0,3-3h2A5.2668,5.2668,0,0,1,16,24Z"
});

var _ref370 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z"
});

var RainDrop16 = /*#__PURE__*/React.forwardRef(function RainDrop16(_ref368, ref) {
  var children = _ref368.children,
      rest = _objectWithoutProperties(_ref368, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref369, _ref370, children);
});

var _ref372 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.2 9L28.86 17 28.6 21.54 28.19 18 27.51 12.54 25.49 12.54 24.81 18 24.4 21.54 24.14 17 23.8 9 22 9 23 23 25.27 23 26.03 18.07 26.49 14 26.5 13.97 26.51 14 26.97 18.07 27.73 23 30 23 31 9 29.2 9zM18 9H14a2 2 0 00-2 2V23h2V18h4v5h2V11A2 2 0 0018 9zm-4 7V11h4v5zM10 15V11A2 2 0 008 9H2V23H4V17H5.48l2.34 6H10L7.63 17H8A2 2 0 0010 15zM4 11H8v4H4z"
});

var Raw32 = /*#__PURE__*/React.forwardRef(function Raw32(_ref371, ref) {
  var children = _ref371.children,
      rest = _objectWithoutProperties(_ref371, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref372, children);
});

var _ref374 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.2 9L28.86 17 28.6 21.54 28.19 18 27.51 12.54 25.49 12.54 24.81 18 24.4 21.54 24.14 17 23.8 9 22 9 23 23 25.27 23 26.03 18.07 26.49 14 26.5 13.97 26.51 14 26.97 18.07 27.73 23 30 23 31 9 29.2 9zM18 9H14a2 2 0 00-2 2V23h2V18h4v5h2V11A2 2 0 0018 9zm-4 7V11h4v5zM10 15V11A2 2 0 008 9H2V23H4V17H5.48l2.34 6H10L7.63 17H8A2 2 0 0010 15zM4 11H8v4H4z"
});

var Raw24 = /*#__PURE__*/React.forwardRef(function Raw24(_ref373, ref) {
  var children = _ref373.children,
      rest = _objectWithoutProperties(_ref373, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref374, children);
});

var _ref376 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.2 9L28.86 17 28.6 21.54 28.19 18 27.51 12.54 25.49 12.54 24.81 18 24.4 21.54 24.14 17 23.8 9 22 9 23 23 25.27 23 26.03 18.07 26.49 14 26.5 13.97 26.51 14 26.97 18.07 27.73 23 30 23 31 9 29.2 9zM18 9H14a2 2 0 00-2 2V23h2V18h4v5h2V11A2 2 0 0018 9zm-4 7V11h4v5zM10 15V11A2 2 0 008 9H2V23H4V17H5.48l2.34 6H10L7.63 17H8A2 2 0 0010 15zM4 11H8v4H4z"
});

var Raw20 = /*#__PURE__*/React.forwardRef(function Raw20(_ref375, ref) {
  var children = _ref375.children,
      rest = _objectWithoutProperties(_ref375, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref376, children);
});

var _ref378 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.2 9L28.86 17 28.6 21.54 28.19 18 27.51 12.54 25.49 12.54 24.81 18 24.4 21.54 24.14 17 23.8 9 22 9 23 23 25.27 23 26.03 18.07 26.49 14 26.5 13.97 26.51 14 26.97 18.07 27.73 23 30 23 31 9 29.2 9zM18 9H14a2 2 0 00-2 2V23h2V18h4v5h2V11A2 2 0 0018 9zm-4 7V11h4v5zM10 15V11A2 2 0 008 9H2V23H4V17H5.48l2.34 6H10L7.63 17H8A2 2 0 0010 15zM4 11H8v4H4z"
});

var Raw16 = /*#__PURE__*/React.forwardRef(function Raw16(_ref377, ref) {
  var children = _ref377.children,
      rest = _objectWithoutProperties(_ref377, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref378, children);
});

var _ref380 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 16H23V18H21zM9 16H17V18H9zM21 12H23V14H21zM9 12H17V14H9zM9 8H23V10H9z"
});

var _ref381 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,2H7A2.002,2.002,0,0,0,5,4V29a1,1,0,0,0,1,1H7a.9987.9987,0,0,0,.8-.4L10,26.667,12.2,29.6a1.0353,1.0353,0,0,0,1.6,0L16,26.667,18.2,29.6a1.0353,1.0353,0,0,0,1.6,0L22,26.667,24.2,29.6a.9993.9993,0,0,0,.8.4h1a1,1,0,0,0,1-1V4A2.0023,2.0023,0,0,0,25,2Zm0,25.333L22.8,24.4a1.0353,1.0353,0,0,0-1.6,0L19,27.333,16.8,24.4a1.0353,1.0353,0,0,0-1.6,0L13,27.333,10.8,24.4a1.0353,1.0353,0,0,0-1.6,0L7,27.333V4H25Z"
});

var Receipt32 = /*#__PURE__*/React.forwardRef(function Receipt32(_ref379, ref) {
  var children = _ref379.children,
      rest = _objectWithoutProperties(_ref379, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref380, _ref381, children);
});

var _ref383 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 16H23V18H21zM9 16H17V18H9zM21 12H23V14H21zM9 12H17V14H9zM9 8H23V10H9z"
});

var _ref384 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,2H7A2.002,2.002,0,0,0,5,4V29a1,1,0,0,0,1,1H7a.9987.9987,0,0,0,.8-.4L10,26.667,12.2,29.6a1.0353,1.0353,0,0,0,1.6,0L16,26.667,18.2,29.6a1.0353,1.0353,0,0,0,1.6,0L22,26.667,24.2,29.6a.9993.9993,0,0,0,.8.4h1a1,1,0,0,0,1-1V4A2.0023,2.0023,0,0,0,25,2Zm0,25.333L22.8,24.4a1.0353,1.0353,0,0,0-1.6,0L19,27.333,16.8,24.4a1.0353,1.0353,0,0,0-1.6,0L13,27.333,10.8,24.4a1.0353,1.0353,0,0,0-1.6,0L7,27.333V4H25Z"
});

var Receipt24 = /*#__PURE__*/React.forwardRef(function Receipt24(_ref382, ref) {
  var children = _ref382.children,
      rest = _objectWithoutProperties(_ref382, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref383, _ref384, children);
});

var _ref386 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 16H23V18H21zM9 16H17V18H9zM21 12H23V14H21zM9 12H17V14H9zM9 8H23V10H9z"
});

var _ref387 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,2H7A2.002,2.002,0,0,0,5,4V29a1,1,0,0,0,1,1H7a.9987.9987,0,0,0,.8-.4L10,26.667,12.2,29.6a1.0353,1.0353,0,0,0,1.6,0L16,26.667,18.2,29.6a1.0353,1.0353,0,0,0,1.6,0L22,26.667,24.2,29.6a.9993.9993,0,0,0,.8.4h1a1,1,0,0,0,1-1V4A2.0023,2.0023,0,0,0,25,2Zm0,25.333L22.8,24.4a1.0353,1.0353,0,0,0-1.6,0L19,27.333,16.8,24.4a1.0353,1.0353,0,0,0-1.6,0L13,27.333,10.8,24.4a1.0353,1.0353,0,0,0-1.6,0L7,27.333V4H25Z"
});

var Receipt20 = /*#__PURE__*/React.forwardRef(function Receipt20(_ref385, ref) {
  var children = _ref385.children,
      rest = _objectWithoutProperties(_ref385, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref386, _ref387, children);
});

var _ref389 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 16H23V18H21zM9 16H17V18H9zM21 12H23V14H21zM9 12H17V14H9zM9 8H23V10H9z"
});

var _ref390 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,2H7A2.002,2.002,0,0,0,5,4V29a1,1,0,0,0,1,1H7a.9987.9987,0,0,0,.8-.4L10,26.667,12.2,29.6a1.0353,1.0353,0,0,0,1.6,0L16,26.667,18.2,29.6a1.0353,1.0353,0,0,0,1.6,0L22,26.667,24.2,29.6a.9993.9993,0,0,0,.8.4h1a1,1,0,0,0,1-1V4A2.0023,2.0023,0,0,0,25,2Zm0,25.333L22.8,24.4a1.0353,1.0353,0,0,0-1.6,0L19,27.333,16.8,24.4a1.0353,1.0353,0,0,0-1.6,0L13,27.333,10.8,24.4a1.0353,1.0353,0,0,0-1.6,0L7,27.333V4H25Z"
});

var Receipt16 = /*#__PURE__*/React.forwardRef(function Receipt16(_ref388, ref) {
  var children = _ref388.children,
      rest = _objectWithoutProperties(_ref388, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref389, _ref390, children);
});

var _ref392 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20.59 22L15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z"
});

var _ref393 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A13.94,13.94,0,0,0,6,6.23V2H4v8h8V8H7.08A12,12,0,1,1,4,16H2A14,14,0,1,0,16,2Z"
});

var RecentlyViewed32 = /*#__PURE__*/React.forwardRef(function RecentlyViewed32(_ref391, ref) {
  var children = _ref391.children,
      rest = _objectWithoutProperties(_ref391, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref392, _ref393, children);
});

var _ref395 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20.59 22L15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z"
});

var _ref396 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A13.94,13.94,0,0,0,6,6.23V2H4v8h8V8H7.08A12,12,0,1,1,4,16H2A14,14,0,1,0,16,2Z"
});

var RecentlyViewed24 = /*#__PURE__*/React.forwardRef(function RecentlyViewed24(_ref394, ref) {
  var children = _ref394.children,
      rest = _objectWithoutProperties(_ref394, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref395, _ref396, children);
});

var _ref398 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20.59 22L15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z"
});

var _ref399 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A13.94,13.94,0,0,0,6,6.23V2H4v8h8V8H7.08A12,12,0,1,1,4,16H2A14,14,0,1,0,16,2Z"
});

var RecentlyViewed20 = /*#__PURE__*/React.forwardRef(function RecentlyViewed20(_ref397, ref) {
  var children = _ref397.children,
      rest = _objectWithoutProperties(_ref397, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref398, _ref399, children);
});

var _ref401 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20.59 22L15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z"
});

var _ref402 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A13.94,13.94,0,0,0,6,6.23V2H4v8h8V8H7.08A12,12,0,1,1,4,16H2A14,14,0,1,0,16,2Z"
});

var RecentlyViewed16 = /*#__PURE__*/React.forwardRef(function RecentlyViewed16(_ref400, ref) {
  var children = _ref400.children,
      rest = _objectWithoutProperties(_ref400, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref401, _ref402, children);
});

var _ref404 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2a9,9,0,0,0-6,15.69V30l6-4,6,4V17.69A9,9,0,0,0,16,2Zm4,24.26-2.89-1.92L16,23.6l-1.11.74L12,26.26V19.05a8.88,8.88,0,0,0,8,0ZM20.89,16A7,7,0,1,1,23,11,7,7,0,0,1,20.89,16Z"
});

var Recommend32 = /*#__PURE__*/React.forwardRef(function Recommend32(_ref403, ref) {
  var children = _ref403.children,
      rest = _objectWithoutProperties(_ref403, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref404, children);
});

var _ref406 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2a9,9,0,0,0-6,15.69V30l6-4,6,4V17.69A9,9,0,0,0,16,2Zm4,24.26-2.89-1.92L16,23.6l-1.11.74L12,26.26V19.05a8.88,8.88,0,0,0,8,0ZM20.89,16A7,7,0,1,1,23,11,7,7,0,0,1,20.89,16Z"
});

var Recommend24 = /*#__PURE__*/React.forwardRef(function Recommend24(_ref405, ref) {
  var children = _ref405.children,
      rest = _objectWithoutProperties(_ref405, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref406, children);
});

var _ref408 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2a9,9,0,0,0-6,15.69V30l6-4,6,4V17.69A9,9,0,0,0,16,2Zm4,24.26-2.89-1.92L16,23.6l-1.11.74L12,26.26V19.05a8.88,8.88,0,0,0,8,0ZM20.89,16A7,7,0,1,1,23,11,7,7,0,0,1,20.89,16Z"
});

var Recommend20 = /*#__PURE__*/React.forwardRef(function Recommend20(_ref407, ref) {
  var children = _ref407.children,
      rest = _objectWithoutProperties(_ref407, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref408, children);
});

var _ref410 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2a9,9,0,0,0-6,15.69V30l6-4,6,4V17.69A9,9,0,0,0,16,2Zm4,24.26-2.89-1.92L16,23.6l-1.11.74L12,26.26V19.05a8.88,8.88,0,0,0,8,0ZM20.89,16A7,7,0,1,1,23,11,7,7,0,0,1,20.89,16Z"
});

var Recommend16 = /*#__PURE__*/React.forwardRef(function Recommend16(_ref409, ref) {
  var children = _ref409.children,
      rest = _objectWithoutProperties(_ref409, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref410, children);
});

var _ref412 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
});

var _ref413 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
});

var Recording32 = /*#__PURE__*/React.forwardRef(function Recording32(_ref411, ref) {
  var children = _ref411.children,
      rest = _objectWithoutProperties(_ref411, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref412, _ref413, children);
});

var _ref415 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
});

var _ref416 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
});

var Recording24 = /*#__PURE__*/React.forwardRef(function Recording24(_ref414, ref) {
  var children = _ref414.children,
      rest = _objectWithoutProperties(_ref414, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref415, _ref416, children);
});

var _ref418 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
});

var _ref419 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
});

var Recording20 = /*#__PURE__*/React.forwardRef(function Recording20(_ref417, ref) {
  var children = _ref417.children,
      rest = _objectWithoutProperties(_ref417, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref418, _ref419, children);
});

var _ref421 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
});

var _ref422 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
});

var Recording16 = /*#__PURE__*/React.forwardRef(function Recording16(_ref420, ref) {
  var children = _ref420.children,
      rest = _objectWithoutProperties(_ref420, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref421, _ref422, children);
});

var _ref424 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "4"
});

var _ref425 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S19.3,22,16,22z"
});

var RecordingFilled32 = /*#__PURE__*/React.forwardRef(function RecordingFilled32(_ref423, ref) {
  var children = _ref423.children,
      rest = _objectWithoutProperties(_ref423, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref424, _ref425, children);
});

var _ref427 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "4"
});

var _ref428 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S19.3,22,16,22z"
});

var RecordingFilled24 = /*#__PURE__*/React.forwardRef(function RecordingFilled24(_ref426, ref) {
  var children = _ref426.children,
      rest = _objectWithoutProperties(_ref426, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref427, _ref428, children);
});

var _ref430 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "4"
});

var _ref431 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S19.3,22,16,22z"
});

var RecordingFilled20 = /*#__PURE__*/React.forwardRef(function RecordingFilled20(_ref429, ref) {
  var children = _ref429.children,
      rest = _objectWithoutProperties(_ref429, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref430, _ref431, children);
});

var _ref433 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "4"
});

var _ref434 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S19.3,22,16,22z"
});

var RecordingFilled16 = /*#__PURE__*/React.forwardRef(function RecordingFilled16(_ref432, ref) {
  var children = _ref432.children,
      rest = _objectWithoutProperties(_ref432, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref433, _ref434, children);
});

var _ref436 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S19.3,22,16,22\tz"
});

var _ref437 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,10c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S19.3,10,16,10z",
  "data-icon-path": "inner-path",
  opacity: "0"
});

var RecordingFilledAlt32 = /*#__PURE__*/React.forwardRef(function RecordingFilledAlt32(_ref435, ref) {
  var children = _ref435.children,
      rest = _objectWithoutProperties(_ref435, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref436, _ref437, children);
});

var _ref439 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S19.3,22,16,22\tz"
});

var _ref440 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,10c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S19.3,10,16,10z",
  "data-icon-path": "inner-path",
  opacity: "0"
});

var RecordingFilledAlt24 = /*#__PURE__*/React.forwardRef(function RecordingFilledAlt24(_ref438, ref) {
  var children = _ref438.children,
      rest = _objectWithoutProperties(_ref438, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref439, _ref440, children);
});

var _ref442 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S19.3,22,16,22\tz"
});

var _ref443 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,10c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S19.3,10,16,10z",
  "data-icon-path": "inner-path",
  opacity: "0"
});

var RecordingFilledAlt20 = /*#__PURE__*/React.forwardRef(function RecordingFilledAlt20(_ref441, ref) {
  var children = _ref441.children,
      rest = _objectWithoutProperties(_ref441, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref442, _ref443, children);
});

var _ref445 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S19.3,22,16,22\tz"
});

var _ref446 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,10c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S19.3,10,16,10z",
  "data-icon-path": "inner-path",
  opacity: "0"
});

var RecordingFilledAlt16 = /*#__PURE__*/React.forwardRef(function RecordingFilledAlt16(_ref444, ref) {
  var children = _ref444.children,
      rest = _objectWithoutProperties(_ref444, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref445, _ref446, children);
});

var _ref448 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9,15c-2.5,0-4,1.5-4,4c0,2.5,1.5,4,4,4h5v2H9c-3.5,0-6-2.5-6-6c0-3.5,2.5-6,6-6h16.2l-4-4l1.4-1.5L29,14\tl-6.4,6.4L21.2,19l4-4H9z"
});

var Redo32 = /*#__PURE__*/React.forwardRef(function Redo32(_ref447, ref) {
  var children = _ref447.children,
      rest = _objectWithoutProperties(_ref447, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref448, children);
});

var _ref450 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.8,11.2c-1.8,0-3.2,1.7-3.2,3.3c0,1.5,1.5,3.2,3.2,3.2H10v1.5H6.8C4.6,19.2,2,17,2,14.5s2-4.8,4.8-4.8\th12.4l-3-3l1.1-1.1l4.8,4.8l-4.8,4.8l-1.1-1.1l3-3H6.8z"
});

var Redo24 = /*#__PURE__*/React.forwardRef(function Redo24(_ref449, ref) {
  var children = _ref449.children,
      rest = _objectWithoutProperties(_ref449, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref450, children);
});

var _ref452 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5,9.3c-1.5,0-2.8,1.3-2.8,2.7c0,1.5,1.3,2.7,2.8,2.7h4V16H5c-2.3,0-4-1.7-4-4c0-2.2,1.8-4,4-4h11.6\tl-2.5-2.5L15,4.6l4,4l-4,4l-0.9-0.9l2.5-2.5H5z"
});

var Redo20 = /*#__PURE__*/React.forwardRef(function Redo20(_ref451, ref) {
  var children = _ref451.children,
      rest = _objectWithoutProperties(_ref451, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref452, children);
});

var _ref454 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4,8c-1.2,0-2,0.8-2,2c0,1.2,0.8,2,2,2h3v1H4c-1.7,0-3-1.2-3-3c0-1.7,1.3-3,3-3l9.1,0l-2-2l0.7-0.7\tL15,7.5l-3.2,3.2L11.1,10l2-2L4,8z"
});

var Redo16 = /*#__PURE__*/React.forwardRef(function Redo16(_ref453, ref) {
  var children = _ref453.children,
      rest = _objectWithoutProperties(_ref453, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref454, children);
});

var _ref456 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.386,15.2105l9-7A1,1,0,0,1,30,9V23a1,1,0,0,1-1.614.79l-9-7a1,1,0,0,1,0-1.5791Z"
});

var _ref457 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2H17V30H15z",
  transform: "rotate(-180 16 16)"
});

var _ref458 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13,16a1.001,1.001,0,0,1-.386.79l-9,7A1,1,0,0,1,2,23V9a1,1,0,0,1,1.614-.79l9,7A1.001,1.001,0,0,1,13,16ZM4,20.9556,10.3711,16,4,11.0444Z"
});

var ReflectHorizontal32 = /*#__PURE__*/React.forwardRef(function ReflectHorizontal32(_ref455, ref) {
  var children = _ref455.children,
      rest = _objectWithoutProperties(_ref455, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref456, _ref457, _ref458, children);
});

var _ref460 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.386,15.2105l9-7A1,1,0,0,1,30,9V23a1,1,0,0,1-1.614.79l-9-7a1,1,0,0,1,0-1.5791Z"
});

var _ref461 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2H17V30H15z",
  transform: "rotate(-180 16 16)"
});

var _ref462 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13,16a1.001,1.001,0,0,1-.386.79l-9,7A1,1,0,0,1,2,23V9a1,1,0,0,1,1.614-.79l9,7A1.001,1.001,0,0,1,13,16ZM4,20.9556,10.3711,16,4,11.0444Z"
});

var ReflectHorizontal24 = /*#__PURE__*/React.forwardRef(function ReflectHorizontal24(_ref459, ref) {
  var children = _ref459.children,
      rest = _objectWithoutProperties(_ref459, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref460, _ref461, _ref462, children);
});

var _ref464 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.386,15.2105l9-7A1,1,0,0,1,30,9V23a1,1,0,0,1-1.614.79l-9-7a1,1,0,0,1,0-1.5791Z"
});

var _ref465 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2H17V30H15z",
  transform: "rotate(-180 16 16)"
});

var _ref466 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13,16a1.001,1.001,0,0,1-.386.79l-9,7A1,1,0,0,1,2,23V9a1,1,0,0,1,1.614-.79l9,7A1.001,1.001,0,0,1,13,16ZM4,20.9556,10.3711,16,4,11.0444Z"
});

var ReflectHorizontal20 = /*#__PURE__*/React.forwardRef(function ReflectHorizontal20(_ref463, ref) {
  var children = _ref463.children,
      rest = _objectWithoutProperties(_ref463, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref464, _ref465, _ref466, children);
});

var _ref468 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.386,15.2105l9-7A1,1,0,0,1,30,9V23a1,1,0,0,1-1.614.79l-9-7a1,1,0,0,1,0-1.5791Z"
});

var _ref469 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2H17V30H15z",
  transform: "rotate(-180 16 16)"
});

var _ref470 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13,16a1.001,1.001,0,0,1-.386.79l-9,7A1,1,0,0,1,2,23V9a1,1,0,0,1,1.614-.79l9,7A1.001,1.001,0,0,1,13,16ZM4,20.9556,10.3711,16,4,11.0444Z"
});

var ReflectHorizontal16 = /*#__PURE__*/React.forwardRef(function ReflectHorizontal16(_ref467, ref) {
  var children = _ref467.children,
      rest = _objectWithoutProperties(_ref467, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref468, _ref469, _ref470, children);
});

var _ref472 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16.79,19.386l7,9A1,1,0,0,1,23,30H9a1,1,0,0,1-.79-1.614l7-9a1,1,0,0,1,1.5791,0Z"
});

var _ref473 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2H17V30H15z",
  transform: "rotate(-90 16 16)"
});

var _ref474 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,13a1.001,1.001,0,0,1-.79-.386l-7-9A1,1,0,0,1,9,2H23a1,1,0,0,1,.79,1.614l-7,9A1.001,1.001,0,0,1,16,13ZM11.0444,4,16,10.3711,20.9556,4Z"
});

var ReflectVertical32 = /*#__PURE__*/React.forwardRef(function ReflectVertical32(_ref471, ref) {
  var children = _ref471.children,
      rest = _objectWithoutProperties(_ref471, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref472, _ref473, _ref474, children);
});

var _ref476 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16.79,19.386l7,9A1,1,0,0,1,23,30H9a1,1,0,0,1-.79-1.614l7-9a1,1,0,0,1,1.5791,0Z"
});

var _ref477 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2H17V30H15z",
  transform: "rotate(-90 16 16)"
});

var _ref478 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,13a1.001,1.001,0,0,1-.79-.386l-7-9A1,1,0,0,1,9,2H23a1,1,0,0,1,.79,1.614l-7,9A1.001,1.001,0,0,1,16,13ZM11.0444,4,16,10.3711,20.9556,4Z"
});

var ReflectVertical24 = /*#__PURE__*/React.forwardRef(function ReflectVertical24(_ref475, ref) {
  var children = _ref475.children,
      rest = _objectWithoutProperties(_ref475, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref476, _ref477, _ref478, children);
});

var _ref480 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16.79,19.386l7,9A1,1,0,0,1,23,30H9a1,1,0,0,1-.79-1.614l7-9a1,1,0,0,1,1.5791,0Z"
});

var _ref481 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2H17V30H15z",
  transform: "rotate(-90 16 16)"
});

var _ref482 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,13a1.001,1.001,0,0,1-.79-.386l-7-9A1,1,0,0,1,9,2H23a1,1,0,0,1,.79,1.614l-7,9A1.001,1.001,0,0,1,16,13ZM11.0444,4,16,10.3711,20.9556,4Z"
});

var ReflectVertical20 = /*#__PURE__*/React.forwardRef(function ReflectVertical20(_ref479, ref) {
  var children = _ref479.children,
      rest = _objectWithoutProperties(_ref479, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref480, _ref481, _ref482, children);
});

var _ref484 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16.79,19.386l7,9A1,1,0,0,1,23,30H9a1,1,0,0,1-.79-1.614l7-9a1,1,0,0,1,1.5791,0Z"
});

var _ref485 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2H17V30H15z",
  transform: "rotate(-90 16 16)"
});

var _ref486 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,13a1.001,1.001,0,0,1-.79-.386l-7-9A1,1,0,0,1,9,2H23a1,1,0,0,1,.79,1.614l-7,9A1.001,1.001,0,0,1,16,13ZM11.0444,4,16,10.3711,20.9556,4Z"
});

var ReflectVertical16 = /*#__PURE__*/React.forwardRef(function ReflectVertical16(_ref483, ref) {
  var children = _ref483.children,
      rest = _objectWithoutProperties(_ref483, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref484, _ref485, _ref486, children);
});

var _ref488 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
});

var _ref489 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16H28A12,12,0,1,0,16,28Z"
});

var WatsonHealthRegionAnalysisArea32 = /*#__PURE__*/React.forwardRef(function WatsonHealthRegionAnalysisArea32(_ref487, ref) {
  var children = _ref487.children,
      rest = _objectWithoutProperties(_ref487, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref488, _ref489, children);
});

var _ref491 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
});

var _ref492 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16H28A12,12,0,1,0,16,28Z"
});

var WatsonHealthRegionAnalysisArea24 = /*#__PURE__*/React.forwardRef(function WatsonHealthRegionAnalysisArea24(_ref490, ref) {
  var children = _ref490.children,
      rest = _objectWithoutProperties(_ref490, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref491, _ref492, children);
});

var _ref494 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
});

var _ref495 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16H28A12,12,0,1,0,16,28Z"
});

var WatsonHealthRegionAnalysisArea20 = /*#__PURE__*/React.forwardRef(function WatsonHealthRegionAnalysisArea20(_ref493, ref) {
  var children = _ref493.children,
      rest = _objectWithoutProperties(_ref493, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref494, _ref495, children);
});

var _ref497 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
});

var _ref498 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16H28A12,12,0,1,0,16,28Z"
});

var WatsonHealthRegionAnalysisArea16 = /*#__PURE__*/React.forwardRef(function WatsonHealthRegionAnalysisArea16(_ref496, ref) {
  var children = _ref496.children,
      rest = _objectWithoutProperties(_ref496, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref497, _ref498, children);
});

var _ref500 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
});

var _ref501 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4.8305,20.3555A24.9534,24.9534,0,0,0,15,22.9644v-2A22.9014,22.9014,0,0,1,4.1335,17.6919,11.979,11.979,0,0,1,4,16a11.9847,11.9847,0,0,1,.1332-1.69,22.9282,22.9282,0,0,1,23.7336,0A11.9847,11.9847,0,0,1,28,16h2A14,14,0,1,0,16,30V28A12.01,12.01,0,0,1,4.8305,20.3555ZM16,4a12.01,12.01,0,0,1,11.17,7.6465,24.8982,24.8982,0,0,0-22.3406,0A12.01,12.01,0,0,1,16,4Z"
});

var WatsonHealthRegionAnalysisVolume32 = /*#__PURE__*/React.forwardRef(function WatsonHealthRegionAnalysisVolume32(_ref499, ref) {
  var children = _ref499.children,
      rest = _objectWithoutProperties(_ref499, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref500, _ref501, children);
});

var _ref503 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
});

var _ref504 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4.8305,20.3555A24.9534,24.9534,0,0,0,15,22.9644v-2A22.9014,22.9014,0,0,1,4.1335,17.6919,11.979,11.979,0,0,1,4,16a11.9847,11.9847,0,0,1,.1332-1.69,22.9282,22.9282,0,0,1,23.7336,0A11.9847,11.9847,0,0,1,28,16h2A14,14,0,1,0,16,30V28A12.01,12.01,0,0,1,4.8305,20.3555ZM16,4a12.01,12.01,0,0,1,11.17,7.6465,24.8982,24.8982,0,0,0-22.3406,0A12.01,12.01,0,0,1,16,4Z"
});

var WatsonHealthRegionAnalysisVolume24 = /*#__PURE__*/React.forwardRef(function WatsonHealthRegionAnalysisVolume24(_ref502, ref) {
  var children = _ref502.children,
      rest = _objectWithoutProperties(_ref502, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref503, _ref504, children);
});

var _ref506 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
});

var _ref507 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4.8305,20.3555A24.9534,24.9534,0,0,0,15,22.9644v-2A22.9014,22.9014,0,0,1,4.1335,17.6919,11.979,11.979,0,0,1,4,16a11.9847,11.9847,0,0,1,.1332-1.69,22.9282,22.9282,0,0,1,23.7336,0A11.9847,11.9847,0,0,1,28,16h2A14,14,0,1,0,16,30V28A12.01,12.01,0,0,1,4.8305,20.3555ZM16,4a12.01,12.01,0,0,1,11.17,7.6465,24.8982,24.8982,0,0,0-22.3406,0A12.01,12.01,0,0,1,16,4Z"
});

var WatsonHealthRegionAnalysisVolume20 = /*#__PURE__*/React.forwardRef(function WatsonHealthRegionAnalysisVolume20(_ref505, ref) {
  var children = _ref505.children,
      rest = _objectWithoutProperties(_ref505, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref506, _ref507, children);
});

var _ref509 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
});

var _ref510 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4.8305,20.3555A24.9534,24.9534,0,0,0,15,22.9644v-2A22.9014,22.9014,0,0,1,4.1335,17.6919,11.979,11.979,0,0,1,4,16a11.9847,11.9847,0,0,1,.1332-1.69,22.9282,22.9282,0,0,1,23.7336,0A11.9847,11.9847,0,0,1,28,16h2A14,14,0,1,0,16,30V28A12.01,12.01,0,0,1,4.8305,20.3555ZM16,4a12.01,12.01,0,0,1,11.17,7.6465,24.8982,24.8982,0,0,0-22.3406,0A12.01,12.01,0,0,1,16,4Z"
});

var WatsonHealthRegionAnalysisVolume16 = /*#__PURE__*/React.forwardRef(function WatsonHealthRegionAnalysisVolume16(_ref508, ref) {
  var children = _ref508.children,
      rest = _objectWithoutProperties(_ref508, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref509, _ref510, children);
});

var _ref512 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 25H20a2.0027 2.0027 0 01-2-2V20h2v3h8V9H20v3H18V9a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2V23A2.0027 2.0027 0 0128 25zM8 15H12V17H8z"
});

var _ref513 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 15H24V17H20zM14 15H18V17H14zM12 25H4a2.0023 2.0023 0 01-2-2V9A2.002 2.002 0 014 7h8a2.002 2.002 0 012 2v3H12V9H4V23h8V20h2v3A2.0023 2.0023 0 0112 25z"
});

var WatsonHealthRegistration32 = /*#__PURE__*/React.forwardRef(function WatsonHealthRegistration32(_ref511, ref) {
  var children = _ref511.children,
      rest = _objectWithoutProperties(_ref511, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref512, _ref513, children);
});

var _ref515 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 25H20a2.0027 2.0027 0 01-2-2V20h2v3h8V9H20v3H18V9a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2V23A2.0027 2.0027 0 0128 25zM8 15H12V17H8z"
});

var _ref516 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 15H24V17H20zM14 15H18V17H14zM12 25H4a2.0023 2.0023 0 01-2-2V9A2.002 2.002 0 014 7h8a2.002 2.002 0 012 2v3H12V9H4V23h8V20h2v3A2.0023 2.0023 0 0112 25z"
});

var WatsonHealthRegistration24 = /*#__PURE__*/React.forwardRef(function WatsonHealthRegistration24(_ref514, ref) {
  var children = _ref514.children,
      rest = _objectWithoutProperties(_ref514, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref515, _ref516, children);
});

var _ref518 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 25H20a2.0027 2.0027 0 01-2-2V20h2v3h8V9H20v3H18V9a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2V23A2.0027 2.0027 0 0128 25zM8 15H12V17H8z"
});

var _ref519 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 15H24V17H20zM14 15H18V17H14zM12 25H4a2.0023 2.0023 0 01-2-2V9A2.002 2.002 0 014 7h8a2.002 2.002 0 012 2v3H12V9H4V23h8V20h2v3A2.0023 2.0023 0 0112 25z"
});

var WatsonHealthRegistration20 = /*#__PURE__*/React.forwardRef(function WatsonHealthRegistration20(_ref517, ref) {
  var children = _ref517.children,
      rest = _objectWithoutProperties(_ref517, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref518, _ref519, children);
});

var _ref521 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 25H20a2.0027 2.0027 0 01-2-2V20h2v3h8V9H20v3H18V9a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2V23A2.0027 2.0027 0 0128 25zM8 15H12V17H8z"
});

var _ref522 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 15H24V17H20zM14 15H18V17H14zM12 25H4a2.0023 2.0023 0 01-2-2V9A2.002 2.002 0 014 7h8a2.002 2.002 0 012 2v3H12V9H4V23h8V20h2v3A2.0023 2.0023 0 0112 25z"
});

var WatsonHealthRegistration16 = /*#__PURE__*/React.forwardRef(function WatsonHealthRegistration16(_ref520, ref) {
  var children = _ref520.children,
      rest = _objectWithoutProperties(_ref520, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref521, _ref522, children);
});

var _ref524 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,23.3818l-2-1V20a6.0046,6.0046,0,0,0-5-5.91V12H21v2.09A6.0046,6.0046,0,0,0,16,20v2.3818l-2,1V28h6v2h4V28h6ZM28,26H16V24.6182l2-1V20a4,4,0,0,1,8,0v3.6182l2,1Z"
});

var _ref525 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
});

var Reminder32 = /*#__PURE__*/React.forwardRef(function Reminder32(_ref523, ref) {
  var children = _ref523.children,
      rest = _objectWithoutProperties(_ref523, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref524, _ref525, children);
});

var _ref527 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,23.3818l-2-1V20a6.0046,6.0046,0,0,0-5-5.91V12H21v2.09A6.0046,6.0046,0,0,0,16,20v2.3818l-2,1V28h6v2h4V28h6ZM28,26H16V24.6182l2-1V20a4,4,0,0,1,8,0v3.6182l2,1Z"
});

var _ref528 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
});

var Reminder24 = /*#__PURE__*/React.forwardRef(function Reminder24(_ref526, ref) {
  var children = _ref526.children,
      rest = _objectWithoutProperties(_ref526, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref527, _ref528, children);
});

var _ref530 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,23.3818l-2-1V20a6.0046,6.0046,0,0,0-5-5.91V12H21v2.09A6.0046,6.0046,0,0,0,16,20v2.3818l-2,1V28h6v2h4V28h6ZM28,26H16V24.6182l2-1V20a4,4,0,0,1,8,0v3.6182l2,1Z"
});

var _ref531 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
});

var Reminder20 = /*#__PURE__*/React.forwardRef(function Reminder20(_ref529, ref) {
  var children = _ref529.children,
      rest = _objectWithoutProperties(_ref529, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref530, _ref531, children);
});

var _ref533 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,23.3818l-2-1V20a6.0046,6.0046,0,0,0-5-5.91V12H21v2.09A6.0046,6.0046,0,0,0,16,20v2.3818l-2,1V28h6v2h4V28h6ZM28,26H16V24.6182l2-1V20a4,4,0,0,1,8,0v3.6182l2,1Z"
});

var _ref534 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
});

var Reminder16 = /*#__PURE__*/React.forwardRef(function Reminder16(_ref532, ref) {
  var children = _ref532.children,
      rest = _objectWithoutProperties(_ref532, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref533, _ref534, children);
});

var _ref536 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,12v2h1v4a3,3,0,0,1-6,0V14h1V12H20v6a5.0083,5.0083,0,0,0,4,4.8989V24a4,4,0,0,1-8,0V21.8157a3,3,0,1,0-2,0V24a6,6,0,0,0,12,0V22.8989A5.0083,5.0083,0,0,0,30,18V12ZM15,18a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,15,18Z"
});

var _ref537 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2l4,0V26L6,26V6h4V8h2V6h8V8h2V6h4v4h2V6A2,2,0,0,0,26,4Z"
});

var ReminderMedical32 = /*#__PURE__*/React.forwardRef(function ReminderMedical32(_ref535, ref) {
  var children = _ref535.children,
      rest = _objectWithoutProperties(_ref535, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref536, _ref537, children);
});

var _ref539 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,12v2h1v4a3,3,0,0,1-6,0V14h1V12H20v6a5.0083,5.0083,0,0,0,4,4.8989V24a4,4,0,0,1-8,0V21.8157a3,3,0,1,0-2,0V24a6,6,0,0,0,12,0V22.8989A5.0083,5.0083,0,0,0,30,18V12ZM15,18a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,15,18Z"
});

var _ref540 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2l4,0V26L6,26V6h4V8h2V6h8V8h2V6h4v4h2V6A2,2,0,0,0,26,4Z"
});

var ReminderMedical24 = /*#__PURE__*/React.forwardRef(function ReminderMedical24(_ref538, ref) {
  var children = _ref538.children,
      rest = _objectWithoutProperties(_ref538, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref539, _ref540, children);
});

var _ref542 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,12v2h1v4a3,3,0,0,1-6,0V14h1V12H20v6a5.0083,5.0083,0,0,0,4,4.8989V24a4,4,0,0,1-8,0V21.8157a3,3,0,1,0-2,0V24a6,6,0,0,0,12,0V22.8989A5.0083,5.0083,0,0,0,30,18V12ZM15,18a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,15,18Z"
});

var _ref543 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2l4,0V26L6,26V6h4V8h2V6h8V8h2V6h4v4h2V6A2,2,0,0,0,26,4Z"
});

var ReminderMedical20 = /*#__PURE__*/React.forwardRef(function ReminderMedical20(_ref541, ref) {
  var children = _ref541.children,
      rest = _objectWithoutProperties(_ref541, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref542, _ref543, children);
});

var _ref545 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,12v2h1v4a3,3,0,0,1-6,0V14h1V12H20v6a5.0083,5.0083,0,0,0,4,4.8989V24a4,4,0,0,1-8,0V21.8157a3,3,0,1,0-2,0V24a6,6,0,0,0,12,0V22.8989A5.0083,5.0083,0,0,0,30,18V12ZM15,18a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,15,18Z"
});

var _ref546 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2l4,0V26L6,26V6h4V8h2V6h8V8h2V6h4v4h2V6A2,2,0,0,0,26,4Z"
});

var ReminderMedical16 = /*#__PURE__*/React.forwardRef(function ReminderMedical16(_ref544, ref) {
  var children = _ref544.children,
      rest = _objectWithoutProperties(_ref544, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref545, _ref546, children);
});

var _ref548 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 10H6.78A11 11 0 0127 16h2A13 13 0 006 7.68V4H4v8h8zM20 22h5.22A11 11 0 015 16H3a13 13 0 0023 8.32V28h2V20H20z"
});

var Renew32 = /*#__PURE__*/React.forwardRef(function Renew32(_ref547, ref) {
  var children = _ref547.children,
      rest = _objectWithoutProperties(_ref547, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref548, children);
});

var _ref550 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 10H6.78A11 11 0 0127 16h2A13 13 0 006 7.68V4H4v8h8zM20 22h5.22A11 11 0 015 16H3a13 13 0 0023 8.32V28h2V20H20z"
});

var Renew24 = /*#__PURE__*/React.forwardRef(function Renew24(_ref549, ref) {
  var children = _ref549.children,
      rest = _objectWithoutProperties(_ref549, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref550, children);
});

var _ref552 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 10H6.78A11 11 0 0127 16h2A13 13 0 006 7.68V4H4v8h8zM20 22h5.22A11 11 0 015 16H3a13 13 0 0023 8.32V28h2V20H20z"
});

var Renew20 = /*#__PURE__*/React.forwardRef(function Renew20(_ref551, ref) {
  var children = _ref551.children,
      rest = _objectWithoutProperties(_ref551, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref552, children);
});

var _ref554 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 10H6.78A11 11 0 0127 16h2A13 13 0 006 7.68V4H4v8h8zM20 22h5.22A11 11 0 015 16H3a13 13 0 0023 8.32V28h2V20H20z"
});

var Renew16 = /*#__PURE__*/React.forwardRef(function Renew16(_ref553, ref) {
  var children = _ref553.children,
      rest = _objectWithoutProperties(_ref553, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref554, children);
});

var _ref556 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 6H5.83L9.41 2.41 8 1 2 7l6 6 1.41-1.41L5.83 8H26v7h2V8A2 2 0 0026 6zM22.59 20.41L26.17 24H6V17H4v7a2 2 0 002 2H26.17l-3.58 3.59L24 31l6-6-6-6z"
});

var Repeat32 = /*#__PURE__*/React.forwardRef(function Repeat32(_ref555, ref) {
  var children = _ref555.children,
      rest = _objectWithoutProperties(_ref555, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref556, children);
});

var _ref558 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 6H5.83L9.41 2.41 8 1 2 7l6 6 1.41-1.41L5.83 8H26v7h2V8A2 2 0 0026 6zM22.59 20.41L26.17 24H6V17H4v7a2 2 0 002 2H26.17l-3.58 3.59L24 31l6-6-6-6z"
});

var Repeat24 = /*#__PURE__*/React.forwardRef(function Repeat24(_ref557, ref) {
  var children = _ref557.children,
      rest = _objectWithoutProperties(_ref557, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref558, children);
});

var _ref560 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 6H5.83L9.41 2.41 8 1 2 7l6 6 1.41-1.41L5.83 8H26v7h2V8A2 2 0 0026 6zM22.59 20.41L26.17 24H6V17H4v7a2 2 0 002 2H26.17l-3.58 3.59L24 31l6-6-6-6z"
});

var Repeat20 = /*#__PURE__*/React.forwardRef(function Repeat20(_ref559, ref) {
  var children = _ref559.children,
      rest = _objectWithoutProperties(_ref559, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref560, children);
});

var _ref562 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 6H5.83L9.41 2.41 8 1 2 7l6 6 1.41-1.41L5.83 8H26v7h2V8A2 2 0 0026 6zM22.59 20.41L26.17 24H6V17H4v7a2 2 0 002 2H26.17l-3.58 3.59L24 31l6-6-6-6z"
});

var Repeat16 = /*#__PURE__*/React.forwardRef(function Repeat16(_ref561, ref) {
  var children = _ref561.children,
      rest = _objectWithoutProperties(_ref561, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref562, children);
});

var _ref564 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 6H5.83L9.41 2.41 8 1 2 7l6 6 1.41-1.41L5.83 8H26v7h2V8A2 2 0 0026 6zM22.59 20.41L26.17 24H6V17H4v7a2 2 0 002 2H26.17l-3.58 3.59L24 31l6-6-6-6z"
});

var _ref565 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 19L17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z"
});

var RepeatOne32 = /*#__PURE__*/React.forwardRef(function RepeatOne32(_ref563, ref) {
  var children = _ref563.children,
      rest = _objectWithoutProperties(_ref563, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref564, _ref565, children);
});

var _ref567 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 6H5.83L9.41 2.41 8 1 2 7l6 6 1.41-1.41L5.83 8H26v7h2V8A2 2 0 0026 6zM22.59 20.41L26.17 24H6V17H4v7a2 2 0 002 2H26.17l-3.58 3.59L24 31l6-6-6-6z"
});

var _ref568 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 19L17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z"
});

var RepeatOne24 = /*#__PURE__*/React.forwardRef(function RepeatOne24(_ref566, ref) {
  var children = _ref566.children,
      rest = _objectWithoutProperties(_ref566, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref567, _ref568, children);
});

var _ref570 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 6H5.83L9.41 2.41 8 1 2 7l6 6 1.41-1.41L5.83 8H26v7h2V8A2 2 0 0026 6zM22.59 20.41L26.17 24H6V17H4v7a2 2 0 002 2H26.17l-3.58 3.59L24 31l6-6-6-6z"
});

var _ref571 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 19L17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z"
});

var RepeatOne20 = /*#__PURE__*/React.forwardRef(function RepeatOne20(_ref569, ref) {
  var children = _ref569.children,
      rest = _objectWithoutProperties(_ref569, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref570, _ref571, children);
});

var _ref573 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 6H5.83L9.41 2.41 8 1 2 7l6 6 1.41-1.41L5.83 8H26v7h2V8A2 2 0 0026 6zM22.59 20.41L26.17 24H6V17H4v7a2 2 0 002 2H26.17l-3.58 3.59L24 31l6-6-6-6z"
});

var _ref574 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 19L17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z"
});

var RepeatOne16 = /*#__PURE__*/React.forwardRef(function RepeatOne16(_ref572, ref) {
  var children = _ref572.children,
      rest = _objectWithoutProperties(_ref572, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref573, _ref574, children);
});

var _ref576 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.88,30a1,1,0,0,1-.88-.5A15.19,15.19,0,0,0,15,22v6a1,1,0,0,1-.62.92,1,1,0,0,1-1.09-.21l-12-12a1,1,0,0,1,0-1.42l12-12a1,1,0,0,1,1.09-.21A1,1,0,0,1,15,4v6.11a17.19,17.19,0,0,1,15,17,16.34,16.34,0,0,1-.13,2,1,1,0,0,1-.79.86ZM14.5,20A17.62,17.62,0,0,1,28,26,15.31,15.31,0,0,0,13.91,12,1,1,0,0,1,13,11V6.41L3.41,16,13,25.59V21a1,1,0,0,1,1-1h.54Z"
});

var Reply32 = /*#__PURE__*/React.forwardRef(function Reply32(_ref575, ref) {
  var children = _ref575.children,
      rest = _objectWithoutProperties(_ref575, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref576, children);
});

var _ref578 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.88,30a1,1,0,0,1-.88-.5A15.19,15.19,0,0,0,15,22v6a1,1,0,0,1-.62.92,1,1,0,0,1-1.09-.21l-12-12a1,1,0,0,1,0-1.42l12-12a1,1,0,0,1,1.09-.21A1,1,0,0,1,15,4v6.11a17.19,17.19,0,0,1,15,17,16.34,16.34,0,0,1-.13,2,1,1,0,0,1-.79.86ZM14.5,20A17.62,17.62,0,0,1,28,26,15.31,15.31,0,0,0,13.91,12,1,1,0,0,1,13,11V6.41L3.41,16,13,25.59V21a1,1,0,0,1,1-1h.54Z"
});

var Reply24 = /*#__PURE__*/React.forwardRef(function Reply24(_ref577, ref) {
  var children = _ref577.children,
      rest = _objectWithoutProperties(_ref577, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref578, children);
});

var _ref580 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.88,30a1,1,0,0,1-.88-.5A15.19,15.19,0,0,0,15,22v6a1,1,0,0,1-.62.92,1,1,0,0,1-1.09-.21l-12-12a1,1,0,0,1,0-1.42l12-12a1,1,0,0,1,1.09-.21A1,1,0,0,1,15,4v6.11a17.19,17.19,0,0,1,15,17,16.34,16.34,0,0,1-.13,2,1,1,0,0,1-.79.86ZM14.5,20A17.62,17.62,0,0,1,28,26,15.31,15.31,0,0,0,13.91,12,1,1,0,0,1,13,11V6.41L3.41,16,13,25.59V21a1,1,0,0,1,1-1h.54Z"
});

var Reply20 = /*#__PURE__*/React.forwardRef(function Reply20(_ref579, ref) {
  var children = _ref579.children,
      rest = _objectWithoutProperties(_ref579, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref580, children);
});

var _ref582 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.88,30a1,1,0,0,1-.88-.5A15.19,15.19,0,0,0,15,22v6a1,1,0,0,1-.62.92,1,1,0,0,1-1.09-.21l-12-12a1,1,0,0,1,0-1.42l12-12a1,1,0,0,1,1.09-.21A1,1,0,0,1,15,4v6.11a17.19,17.19,0,0,1,15,17,16.34,16.34,0,0,1-.13,2,1,1,0,0,1-.79.86ZM14.5,20A17.62,17.62,0,0,1,28,26,15.31,15.31,0,0,0,13.91,12,1,1,0,0,1,13,11V6.41L3.41,16,13,25.59V21a1,1,0,0,1,1-1h.54Z"
});

var Reply16 = /*#__PURE__*/React.forwardRef(function Reply16(_ref581, ref) {
  var children = _ref581.children,
      rest = _objectWithoutProperties(_ref581, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref582, children);
});

var _ref584 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 18H18V20H10zM10 13H22V15H10zM10 23H15V25H10z"
});

var _ref585 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
});

var Report32 = /*#__PURE__*/React.forwardRef(function Report32(_ref583, ref) {
  var children = _ref583.children,
      rest = _objectWithoutProperties(_ref583, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref584, _ref585, children);
});

var _ref587 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 18H18V20H10zM10 13H22V15H10zM10 23H15V25H10z"
});

var _ref588 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
});

var Report24 = /*#__PURE__*/React.forwardRef(function Report24(_ref586, ref) {
  var children = _ref586.children,
      rest = _objectWithoutProperties(_ref586, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref587, _ref588, children);
});

var _ref590 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 18H18V20H10zM10 13H22V15H10zM10 23H15V25H10z"
});

var _ref591 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
});

var Report20 = /*#__PURE__*/React.forwardRef(function Report20(_ref589, ref) {
  var children = _ref589.children,
      rest = _objectWithoutProperties(_ref589, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref590, _ref591, children);
});

var _ref593 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 18H18V20H10zM10 13H22V15H10zM10 23H15V25H10z"
});

var _ref594 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
});

var Report16 = /*#__PURE__*/React.forwardRef(function Report16(_ref592, ref) {
  var children = _ref592.children,
      rest = _objectWithoutProperties(_ref592, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref593, _ref594, children);
});

var _ref596 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 20H17V24H15zM20 18H22V24H20zM10 14H12V24H10z"
});

var _ref597 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
});

var ReportData32 = /*#__PURE__*/React.forwardRef(function ReportData32(_ref595, ref) {
  var children = _ref595.children,
      rest = _objectWithoutProperties(_ref595, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref596, _ref597, children);
});

var _ref599 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 20H17V24H15zM20 18H22V24H20zM10 14H12V24H10z"
});

var _ref600 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
});

var ReportData24 = /*#__PURE__*/React.forwardRef(function ReportData24(_ref598, ref) {
  var children = _ref598.children,
      rest = _objectWithoutProperties(_ref598, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref599, _ref600, children);
});

var _ref602 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 20H17V24H15zM20 18H22V24H20zM10 14H12V24H10z"
});

var _ref603 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
});

var ReportData20 = /*#__PURE__*/React.forwardRef(function ReportData20(_ref601, ref) {
  var children = _ref601.children,
      rest = _objectWithoutProperties(_ref601, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref602, _ref603, children);
});

var _ref605 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 20H17V24H15zM20 18H22V24H20zM10 14H12V24H10z"
});

var _ref606 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
});

var ReportData16 = /*#__PURE__*/React.forwardRef(function ReportData16(_ref604, ref) {
  var children = _ref604.children,
      rest = _objectWithoutProperties(_ref604, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref605, _ref606, children);
});

var _ref608 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22,22v6H6V4H16V2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V22Z"
});

var _ref609 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.54,5.76l-3.3-3.3a1.6,1.6,0,0,0-2.24,0l-14,14V22h5.53l14-14a1.6,1.6,0,0,0,0-2.24ZM14.7,20H12V17.3l9.44-9.45,2.71,2.71ZM25.56,9.15,22.85,6.44l2.27-2.27,2.71,2.71Z"
});

var RequestQuote32 = /*#__PURE__*/React.forwardRef(function RequestQuote32(_ref607, ref) {
  var children = _ref607.children,
      rest = _objectWithoutProperties(_ref607, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref608, _ref609, children);
});

var _ref611 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22,22v6H6V4H16V2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V22Z"
});

var _ref612 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.54,5.76l-3.3-3.3a1.6,1.6,0,0,0-2.24,0l-14,14V22h5.53l14-14a1.6,1.6,0,0,0,0-2.24ZM14.7,20H12V17.3l9.44-9.45,2.71,2.71ZM25.56,9.15,22.85,6.44l2.27-2.27,2.71,2.71Z"
});

var RequestQuote24 = /*#__PURE__*/React.forwardRef(function RequestQuote24(_ref610, ref) {
  var children = _ref610.children,
      rest = _objectWithoutProperties(_ref610, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref611, _ref612, children);
});

var _ref614 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22,22v6H6V4H16V2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V22Z"
});

var _ref615 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.54,5.76l-3.3-3.3a1.6,1.6,0,0,0-2.24,0l-14,14V22h5.53l14-14a1.6,1.6,0,0,0,0-2.24ZM14.7,20H12V17.3l9.44-9.45,2.71,2.71ZM25.56,9.15,22.85,6.44l2.27-2.27,2.71,2.71Z"
});

var RequestQuote20 = /*#__PURE__*/React.forwardRef(function RequestQuote20(_ref613, ref) {
  var children = _ref613.children,
      rest = _objectWithoutProperties(_ref613, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref614, _ref615, children);
});

var _ref617 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22,22v6H6V4H16V2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V22Z"
});

var _ref618 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.54,5.76l-3.3-3.3a1.6,1.6,0,0,0-2.24,0l-14,14V22h5.53l14-14a1.6,1.6,0,0,0,0-2.24ZM14.7,20H12V17.3l9.44-9.45,2.71,2.71ZM25.56,9.15,22.85,6.44l2.27-2.27,2.71,2.71Z"
});

var RequestQuote16 = /*#__PURE__*/React.forwardRef(function RequestQuote16(_ref616, ref) {
  var children = _ref616.children,
      rest = _objectWithoutProperties(_ref616, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref617, _ref618, children);
});

var _ref620 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.87,7.84l-1.74-1L16,14h0a2,2,0,1,0,2,2,2,2,0,0,0-.27-1Z"
});

var _ref621 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,11.17,7.65,25.69,25.69,0,0,0-3.69-1.5l-1,1.77a22.7,22.7,0,0,1,5.41,2.39,11.05,11.05,0,0,1,0,3.38A22.92,22.92,0,0,1,16,21,22.92,22.92,0,0,1,4.13,17.69a11.05,11.05,0,0,1,0-3.38A22.8,22.8,0,0,1,15,11V9a25,25,0,0,0-10.17,2.6A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4.83,20.35,24.88,24.88,0,0,0,16,23a24.88,24.88,0,0,0,11.17-2.65A12,12,0,0,1,16,28Z"
});

var ResearchBlochSphere32 = /*#__PURE__*/React.forwardRef(function ResearchBlochSphere32(_ref619, ref) {
  var children = _ref619.children,
      rest = _objectWithoutProperties(_ref619, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['ResearchBlochSphere32']) {
      didWarnAboutDeprecation['ResearchBlochSphere32'] = true;
      console.warn("The ResearchBlochSphere32 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref620, _ref621, children);
});

var _ref623 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.87,7.84l-1.74-1L16,14h0a2,2,0,1,0,2,2,2,2,0,0,0-.27-1Z"
});

var _ref624 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,11.17,7.65,25.69,25.69,0,0,0-3.69-1.5l-1,1.77a22.7,22.7,0,0,1,5.41,2.39,11.05,11.05,0,0,1,0,3.38A22.92,22.92,0,0,1,16,21,22.92,22.92,0,0,1,4.13,17.69a11.05,11.05,0,0,1,0-3.38A22.8,22.8,0,0,1,15,11V9a25,25,0,0,0-10.17,2.6A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4.83,20.35,24.88,24.88,0,0,0,16,23a24.88,24.88,0,0,0,11.17-2.65A12,12,0,0,1,16,28Z"
});

var ResearchBlochSphere24 = /*#__PURE__*/React.forwardRef(function ResearchBlochSphere24(_ref622, ref) {
  var children = _ref622.children,
      rest = _objectWithoutProperties(_ref622, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['ResearchBlochSphere24']) {
      didWarnAboutDeprecation['ResearchBlochSphere24'] = true;
      console.warn("The ResearchBlochSphere24 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref623, _ref624, children);
});

var _ref626 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.87,7.84l-1.74-1L16,14h0a2,2,0,1,0,2,2,2,2,0,0,0-.27-1Z"
});

var _ref627 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,11.17,7.65,25.69,25.69,0,0,0-3.69-1.5l-1,1.77a22.7,22.7,0,0,1,5.41,2.39,11.05,11.05,0,0,1,0,3.38A22.92,22.92,0,0,1,16,21,22.92,22.92,0,0,1,4.13,17.69a11.05,11.05,0,0,1,0-3.38A22.8,22.8,0,0,1,15,11V9a25,25,0,0,0-10.17,2.6A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4.83,20.35,24.88,24.88,0,0,0,16,23a24.88,24.88,0,0,0,11.17-2.65A12,12,0,0,1,16,28Z"
});

var ResearchBlochSphere20 = /*#__PURE__*/React.forwardRef(function ResearchBlochSphere20(_ref625, ref) {
  var children = _ref625.children,
      rest = _objectWithoutProperties(_ref625, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['ResearchBlochSphere20']) {
      didWarnAboutDeprecation['ResearchBlochSphere20'] = true;
      console.warn("The ResearchBlochSphere20 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref626, _ref627, children);
});

var _ref629 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.87,7.84l-1.74-1L16,14h0a2,2,0,1,0,2,2,2,2,0,0,0-.27-1Z"
});

var _ref630 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,11.17,7.65,25.69,25.69,0,0,0-3.69-1.5l-1,1.77a22.7,22.7,0,0,1,5.41,2.39,11.05,11.05,0,0,1,0,3.38A22.92,22.92,0,0,1,16,21,22.92,22.92,0,0,1,4.13,17.69a11.05,11.05,0,0,1,0-3.38A22.8,22.8,0,0,1,15,11V9a25,25,0,0,0-10.17,2.6A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4.83,20.35,24.88,24.88,0,0,0,16,23a24.88,24.88,0,0,0,11.17-2.65A12,12,0,0,1,16,28Z"
});

var ResearchBlochSphere16 = /*#__PURE__*/React.forwardRef(function ResearchBlochSphere16(_ref628, ref) {
  var children = _ref628.children,
      rest = _objectWithoutProperties(_ref628, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['ResearchBlochSphere16']) {
      didWarnAboutDeprecation['ResearchBlochSphere16'] = true;
      console.warn("The ResearchBlochSphere16 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref629, _ref630, children);
});

var _ref632 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 2H6V6H2zM10 2H14V6H10zM18 2H22V6H18zM26 2H30V6H26zM2 10H6V14H2zM10 10H14V14H10zM18 10H22V14H18zM26 10H30V14H26zM2 18H6V22H2zM10 18H14V22H10zM18 18H22V22H18zM26 18H30V22H26zM2 26H6V30H2zM10 26H14V30H10zM18 26H22V30H18zM26 26H30V30H26z"
});

var ResearchHintonPlot32 = /*#__PURE__*/React.forwardRef(function ResearchHintonPlot32(_ref631, ref) {
  var children = _ref631.children,
      rest = _objectWithoutProperties(_ref631, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['ResearchHintonPlot32']) {
      didWarnAboutDeprecation['ResearchHintonPlot32'] = true;
      console.warn("The ResearchHintonPlot32 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref632, children);
});

var _ref634 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 2H6V6H2zM10 2H14V6H10zM18 2H22V6H18zM26 2H30V6H26zM2 10H6V14H2zM10 10H14V14H10zM18 10H22V14H18zM26 10H30V14H26zM2 18H6V22H2zM10 18H14V22H10zM18 18H22V22H18zM26 18H30V22H26zM2 26H6V30H2zM10 26H14V30H10zM18 26H22V30H18zM26 26H30V30H26z"
});

var ResearchHintonPlot24 = /*#__PURE__*/React.forwardRef(function ResearchHintonPlot24(_ref633, ref) {
  var children = _ref633.children,
      rest = _objectWithoutProperties(_ref633, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['ResearchHintonPlot24']) {
      didWarnAboutDeprecation['ResearchHintonPlot24'] = true;
      console.warn("The ResearchHintonPlot24 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref634, children);
});

var _ref636 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 2H6V6H2zM10 2H14V6H10zM18 2H22V6H18zM26 2H30V6H26zM2 10H6V14H2zM10 10H14V14H10zM18 10H22V14H18zM26 10H30V14H26zM2 18H6V22H2zM10 18H14V22H10zM18 18H22V22H18zM26 18H30V22H26zM2 26H6V30H2zM10 26H14V30H10zM18 26H22V30H18zM26 26H30V30H26z"
});

var ResearchHintonPlot20 = /*#__PURE__*/React.forwardRef(function ResearchHintonPlot20(_ref635, ref) {
  var children = _ref635.children,
      rest = _objectWithoutProperties(_ref635, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['ResearchHintonPlot20']) {
      didWarnAboutDeprecation['ResearchHintonPlot20'] = true;
      console.warn("The ResearchHintonPlot20 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref636, children);
});

var _ref638 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 2H6V6H2zM10 2H14V6H10zM18 2H22V6H18zM26 2H30V6H26zM2 10H6V14H2zM10 10H14V14H10zM18 10H22V14H18zM26 10H30V14H26zM2 18H6V22H2zM10 18H14V22H10zM18 18H22V22H18zM26 18H30V22H26zM2 26H6V30H2zM10 26H14V30H10zM18 26H22V30H18zM26 26H30V30H26z"
});

var ResearchHintonPlot16 = /*#__PURE__*/React.forwardRef(function ResearchHintonPlot16(_ref637, ref) {
  var children = _ref637.children,
      rest = _objectWithoutProperties(_ref637, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['ResearchHintonPlot16']) {
      didWarnAboutDeprecation['ResearchHintonPlot16'] = true;
      console.warn("The ResearchHintonPlot16 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref638, children);
});

var _ref640 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 13L18 4 16 4 16 6 13 6 13 8 16 8 16 13 13 13 13 15 21 15 21 13 18 13zM16.5 20A3.5 3.5 0 1113 23.5 3.5 3.5 0 0116.5 20m0-2A5.5 5.5 0 1022 23.5 5.5 5.5 0 0016.5 18zM8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30zM30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z"
});

var ResearchMatrix32 = /*#__PURE__*/React.forwardRef(function ResearchMatrix32(_ref639, ref) {
  var children = _ref639.children,
      rest = _objectWithoutProperties(_ref639, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['ResearchMatrix32']) {
      didWarnAboutDeprecation['ResearchMatrix32'] = true;
      console.warn("The ResearchMatrix32 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref640, children);
});

var _ref642 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 13L18 4 16 4 16 6 13 6 13 8 16 8 16 13 13 13 13 15 21 15 21 13 18 13zM16.5 20A3.5 3.5 0 1113 23.5 3.5 3.5 0 0116.5 20m0-2A5.5 5.5 0 1022 23.5 5.5 5.5 0 0016.5 18zM8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30zM30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z"
});

var ResearchMatrix24 = /*#__PURE__*/React.forwardRef(function ResearchMatrix24(_ref641, ref) {
  var children = _ref641.children,
      rest = _objectWithoutProperties(_ref641, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['ResearchMatrix24']) {
      didWarnAboutDeprecation['ResearchMatrix24'] = true;
      console.warn("The ResearchMatrix24 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref642, children);
});

var _ref644 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 13L18 4 16 4 16 6 13 6 13 8 16 8 16 13 13 13 13 15 21 15 21 13 18 13zM16.5 20A3.5 3.5 0 1113 23.5 3.5 3.5 0 0116.5 20m0-2A5.5 5.5 0 1022 23.5 5.5 5.5 0 0016.5 18zM8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30zM30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z"
});

var ResearchMatrix20 = /*#__PURE__*/React.forwardRef(function ResearchMatrix20(_ref643, ref) {
  var children = _ref643.children,
      rest = _objectWithoutProperties(_ref643, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['ResearchMatrix20']) {
      didWarnAboutDeprecation['ResearchMatrix20'] = true;
      console.warn("The ResearchMatrix20 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref644, children);
});

var _ref646 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 13L18 4 16 4 16 6 13 6 13 8 16 8 16 13 13 13 13 15 21 15 21 13 18 13zM16.5 20A3.5 3.5 0 1113 23.5 3.5 3.5 0 0116.5 20m0-2A5.5 5.5 0 1022 23.5 5.5 5.5 0 0016.5 18zM8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30zM30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z"
});

var ResearchMatrix16 = /*#__PURE__*/React.forwardRef(function ResearchMatrix16(_ref645, ref) {
  var children = _ref645.children,
      rest = _objectWithoutProperties(_ref645, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['ResearchMatrix16']) {
      didWarnAboutDeprecation['ResearchMatrix16'] = true;
      console.warn("The ResearchMatrix16 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref646, children);
});

var _ref648 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18,28A12,12,0,1,0,6,16v6.2L2.4,18.6,1,20l6,6,6-6-1.4-1.4L8,22.2V16H8A10,10,0,1,1,18,26Z"
});

var Reset32 = /*#__PURE__*/React.forwardRef(function Reset32(_ref647, ref) {
  var children = _ref647.children,
      rest = _objectWithoutProperties(_ref647, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref648, children);
});

var _ref650 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18,28A12,12,0,1,0,6,16v6.2L2.4,18.6,1,20l6,6,6-6-1.4-1.4L8,22.2V16H8A10,10,0,1,1,18,26Z"
});

var Reset24 = /*#__PURE__*/React.forwardRef(function Reset24(_ref649, ref) {
  var children = _ref649.children,
      rest = _objectWithoutProperties(_ref649, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref650, children);
});

var _ref652 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18,28A12,12,0,1,0,6,16v6.2L2.4,18.6,1,20l6,6,6-6-1.4-1.4L8,22.2V16H8A10,10,0,1,1,18,26Z"
});

var Reset20 = /*#__PURE__*/React.forwardRef(function Reset20(_ref651, ref) {
  var children = _ref651.children,
      rest = _objectWithoutProperties(_ref651, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref652, children);
});

var _ref654 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18,28A12,12,0,1,0,6,16v6.2L2.4,18.6,1,20l6,6,6-6-1.4-1.4L8,22.2V16H8A10,10,0,1,1,18,26Z"
});

var Reset16 = /*#__PURE__*/React.forwardRef(function Reset16(_ref653, ref) {
  var children = _ref653.children,
      rest = _objectWithoutProperties(_ref653, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref654, children);
});

var _ref656 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,8H6.83l3.58-3.59L9,3,3,9l6,6,1.41-1.41L6.83,10H27V26H7V19H5v7a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V10A2,2,0,0,0,27,8Z"
});

var ResetAlt32 = /*#__PURE__*/React.forwardRef(function ResetAlt32(_ref655, ref) {
  var children = _ref655.children,
      rest = _objectWithoutProperties(_ref655, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref656, children);
});

var _ref658 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,8H6.83l3.58-3.59L9,3,3,9l6,6,1.41-1.41L6.83,10H27V26H7V19H5v7a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V10A2,2,0,0,0,27,8Z"
});

var ResetAlt24 = /*#__PURE__*/React.forwardRef(function ResetAlt24(_ref657, ref) {
  var children = _ref657.children,
      rest = _objectWithoutProperties(_ref657, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref658, children);
});

var _ref660 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,8H6.83l3.58-3.59L9,3,3,9l6,6,1.41-1.41L6.83,10H27V26H7V19H5v7a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V10A2,2,0,0,0,27,8Z"
});

var ResetAlt20 = /*#__PURE__*/React.forwardRef(function ResetAlt20(_ref659, ref) {
  var children = _ref659.children,
      rest = _objectWithoutProperties(_ref659, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref660, children);
});

var _ref662 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,8H6.83l3.58-3.59L9,3,3,9l6,6,1.41-1.41L6.83,10H27V26H7V19H5v7a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V10A2,2,0,0,0,27,8Z"
});

var ResetAlt16 = /*#__PURE__*/React.forwardRef(function ResetAlt16(_ref661, ref) {
  var children = _ref661.children,
      rest = _objectWithoutProperties(_ref661, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref662, children);
});

var _ref664 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,18A10,10,0,1,1,15,8h6.18L17.6,11.59,19,13l6-6L19,1,17.6,2.41,21.19,6H15A12,12,0,1,0,27,18Z"
});

var Restart32 = /*#__PURE__*/React.forwardRef(function Restart32(_ref663, ref) {
  var children = _ref663.children,
      rest = _objectWithoutProperties(_ref663, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref664, children);
});

var _ref666 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,18A10,10,0,1,1,15,8h6.18L17.6,11.59,19,13l6-6L19,1,17.6,2.41,21.19,6H15A12,12,0,1,0,27,18Z"
});

var Restart24 = /*#__PURE__*/React.forwardRef(function Restart24(_ref665, ref) {
  var children = _ref665.children,
      rest = _objectWithoutProperties(_ref665, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref666, children);
});

var _ref668 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,18A10,10,0,1,1,15,8h6.18L17.6,11.59,19,13l6-6L19,1,17.6,2.41,21.19,6H15A12,12,0,1,0,27,18Z"
});

var Restart20 = /*#__PURE__*/React.forwardRef(function Restart20(_ref667, ref) {
  var children = _ref667.children,
      rest = _objectWithoutProperties(_ref667, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref668, children);
});

var _ref670 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13,9c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5h3.1L9.3,5.8L10,6.5l3-3l-3-3L9.3,1.2L11.1,3H8C4.7,3,2,5.7,2,9s2.7,6,6,6\ts6-2.7,6-6H13z"
});

var Restart16 = /*#__PURE__*/React.forwardRef(function Restart16(_ref669, ref) {
  var children = _ref669.children,
      rest = _objectWithoutProperties(_ref669, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref670, children);
});

var _ref672 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9 2H11V12H9z"
});

var _ref673 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 11a4 4 0 01-8 0V2H4v9a6 6 0 005 5.91V30h2V16.91A6 6 0 0016 11V2H14zM22 2H21V30h2V20h3a2 2 0 002-2V8A5.78 5.78 0 0022 2zm4 16H23V4.09c2.88.56 3 3.54 3 3.91z"
});

var Restaurant32 = /*#__PURE__*/React.forwardRef(function Restaurant32(_ref671, ref) {
  var children = _ref671.children,
      rest = _objectWithoutProperties(_ref671, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref672, _ref673, children);
});

var _ref675 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9 2H11V12H9z"
});

var _ref676 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 11a4 4 0 01-8 0V2H4v9a6 6 0 005 5.91V30h2V16.91A6 6 0 0016 11V2H14zM22 2H21V30h2V20h3a2 2 0 002-2V8A5.78 5.78 0 0022 2zm4 16H23V4.09c2.88.56 3 3.54 3 3.91z"
});

var Restaurant24 = /*#__PURE__*/React.forwardRef(function Restaurant24(_ref674, ref) {
  var children = _ref674.children,
      rest = _objectWithoutProperties(_ref674, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref675, _ref676, children);
});

var _ref678 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9 2H11V12H9z"
});

var _ref679 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 11a4 4 0 01-8 0V2H4v9a6 6 0 005 5.91V30h2V16.91A6 6 0 0016 11V2H14zM22 2H21V30h2V20h3a2 2 0 002-2V8A5.78 5.78 0 0022 2zm4 16H23V4.09c2.88.56 3 3.54 3 3.91z"
});

var Restaurant20 = /*#__PURE__*/React.forwardRef(function Restaurant20(_ref677, ref) {
  var children = _ref677.children,
      rest = _objectWithoutProperties(_ref677, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref678, _ref679, children);
});

var _ref681 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9 2H11V12H9z"
});

var _ref682 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 11a4 4 0 01-8 0V2H4v9a6 6 0 005 5.91V30h2V16.91A6 6 0 0016 11V2H14zM22 2H21V30h2V20h3a2 2 0 002-2V8A5.78 5.78 0 0022 2zm4 16H23V4.09c2.88.56 3 3.54 3 3.91z"
});

var Restaurant16 = /*#__PURE__*/React.forwardRef(function Restaurant16(_ref680, ref) {
  var children = _ref680.children,
      rest = _objectWithoutProperties(_ref680, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref681, _ref682, children);
});

var _ref684 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 11.0005v-8a1 1 0 00-1-1H19a1 1 0 00-1 1v8A6.0039 6.0039 0 0023 16.91V28H19v2H29V28H25V16.91A6.0039 6.0039 0 0030 11.0005zm-10 0V4h8v7.0005a4 4 0 11-8 0zM12 2v9.02a3.9644 3.9644 0 01-3.96 3.96A4.0052 4.0052 0 014 11.02V2H2v9.02a5.9888 5.9888 0 005 5.8652V30H9V16.8953A5.9646 5.9646 0 0014 11.02V2z"
});

var _ref685 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7 2H9V11.98H7z"
});

var RestaurantFine32 = /*#__PURE__*/React.forwardRef(function RestaurantFine32(_ref683, ref) {
  var children = _ref683.children,
      rest = _objectWithoutProperties(_ref683, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref684, _ref685, children);
});

var _ref687 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 11.0005v-8a1 1 0 00-1-1H19a1 1 0 00-1 1v8A6.0039 6.0039 0 0023 16.91V28H19v2H29V28H25V16.91A6.0039 6.0039 0 0030 11.0005zm-10 0V4h8v7.0005a4 4 0 11-8 0zM12 2v9.02a3.9644 3.9644 0 01-3.96 3.96A4.0052 4.0052 0 014 11.02V2H2v9.02a5.9888 5.9888 0 005 5.8652V30H9V16.8953A5.9646 5.9646 0 0014 11.02V2z"
});

var _ref688 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7 2H9V11.98H7z"
});

var RestaurantFine24 = /*#__PURE__*/React.forwardRef(function RestaurantFine24(_ref686, ref) {
  var children = _ref686.children,
      rest = _objectWithoutProperties(_ref686, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref687, _ref688, children);
});

var _ref690 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 11.0005v-8a1 1 0 00-1-1H19a1 1 0 00-1 1v8A6.0039 6.0039 0 0023 16.91V28H19v2H29V28H25V16.91A6.0039 6.0039 0 0030 11.0005zm-10 0V4h8v7.0005a4 4 0 11-8 0zM12 2v9.02a3.9644 3.9644 0 01-3.96 3.96A4.0052 4.0052 0 014 11.02V2H2v9.02a5.9888 5.9888 0 005 5.8652V30H9V16.8953A5.9646 5.9646 0 0014 11.02V2z"
});

var _ref691 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7 2H9V11.98H7z"
});

var RestaurantFine20 = /*#__PURE__*/React.forwardRef(function RestaurantFine20(_ref689, ref) {
  var children = _ref689.children,
      rest = _objectWithoutProperties(_ref689, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref690, _ref691, children);
});

var _ref693 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 11.0005v-8a1 1 0 00-1-1H19a1 1 0 00-1 1v8A6.0039 6.0039 0 0023 16.91V28H19v2H29V28H25V16.91A6.0039 6.0039 0 0030 11.0005zm-10 0V4h8v7.0005a4 4 0 11-8 0zM12 2v9.02a3.9644 3.9644 0 01-3.96 3.96A4.0052 4.0052 0 014 11.02V2H2v9.02a5.9888 5.9888 0 005 5.8652V30H9V16.8953A5.9646 5.9646 0 0014 11.02V2z"
});

var _ref694 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7 2H9V11.98H7z"
});

var RestaurantFine16 = /*#__PURE__*/React.forwardRef(function RestaurantFine16(_ref692, ref) {
  var children = _ref692.children,
      rest = _objectWithoutProperties(_ref692, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref693, _ref694, children);
});

var _ref696 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
});

var _ref697 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.63 22.13a2.84 2.84 0 01-1.28-.27 2.44 2.44 0 01-.89-.77 3.57 3.57 0 01-.52-1.25 7.69 7.69 0 01-.17-1.68 7.83 7.83 0 01.17-1.68 3.65 3.65 0 01.52-1.25 2.44 2.44 0 01.89-.77 2.84 2.84 0 011.28-.27 2.44 2.44 0 012.16 1 5.23 5.23 0 01.7 2.93 5.23 5.23 0 01-.7 2.93A2.44 2.44 0 0119.63 22.13zm0-1.22a1.07 1.07 0 001-.55A3.38 3.38 0 0021 18.85V17.47a3.31 3.31 0 00-.29-1.5 1.23 1.23 0 00-2.06 0 3.31 3.31 0 00-.29 1.5v1.38a3.38 3.38 0 00.29 1.51A1.06 1.06 0 0019.63 20.91zM10.63 22V20.82h2V15.63l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z"
});

var Rewind_1032 = /*#__PURE__*/React.forwardRef(function Rewind_1032(_ref695, ref) {
  var children = _ref695.children,
      rest = _objectWithoutProperties(_ref695, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref696, _ref697, children);
});

var _ref699 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
});

var _ref700 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.63 22.13a2.84 2.84 0 01-1.28-.27 2.44 2.44 0 01-.89-.77 3.57 3.57 0 01-.52-1.25 7.69 7.69 0 01-.17-1.68 7.83 7.83 0 01.17-1.68 3.65 3.65 0 01.52-1.25 2.44 2.44 0 01.89-.77 2.84 2.84 0 011.28-.27 2.44 2.44 0 012.16 1 5.23 5.23 0 01.7 2.93 5.23 5.23 0 01-.7 2.93A2.44 2.44 0 0119.63 22.13zm0-1.22a1.07 1.07 0 001-.55A3.38 3.38 0 0021 18.85V17.47a3.31 3.31 0 00-.29-1.5 1.23 1.23 0 00-2.06 0 3.31 3.31 0 00-.29 1.5v1.38a3.38 3.38 0 00.29 1.51A1.06 1.06 0 0019.63 20.91zM10.63 22V20.82h2V15.63l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z"
});

var Rewind_1024 = /*#__PURE__*/React.forwardRef(function Rewind_1024(_ref698, ref) {
  var children = _ref698.children,
      rest = _objectWithoutProperties(_ref698, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref699, _ref700, children);
});

var _ref702 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
});

var _ref703 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.63 22.13a2.84 2.84 0 01-1.28-.27 2.44 2.44 0 01-.89-.77 3.57 3.57 0 01-.52-1.25 7.69 7.69 0 01-.17-1.68 7.83 7.83 0 01.17-1.68 3.65 3.65 0 01.52-1.25 2.44 2.44 0 01.89-.77 2.84 2.84 0 011.28-.27 2.44 2.44 0 012.16 1 5.23 5.23 0 01.7 2.93 5.23 5.23 0 01-.7 2.93A2.44 2.44 0 0119.63 22.13zm0-1.22a1.07 1.07 0 001-.55A3.38 3.38 0 0021 18.85V17.47a3.31 3.31 0 00-.29-1.5 1.23 1.23 0 00-2.06 0 3.31 3.31 0 00-.29 1.5v1.38a3.38 3.38 0 00.29 1.51A1.06 1.06 0 0019.63 20.91zM10.63 22V20.82h2V15.63l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z"
});

var Rewind_1020 = /*#__PURE__*/React.forwardRef(function Rewind_1020(_ref701, ref) {
  var children = _ref701.children,
      rest = _objectWithoutProperties(_ref701, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref702, _ref703, children);
});

var _ref705 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
});

var _ref706 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.63 22.13a2.84 2.84 0 01-1.28-.27 2.44 2.44 0 01-.89-.77 3.57 3.57 0 01-.52-1.25 7.69 7.69 0 01-.17-1.68 7.83 7.83 0 01.17-1.68 3.65 3.65 0 01.52-1.25 2.44 2.44 0 01.89-.77 2.84 2.84 0 011.28-.27 2.44 2.44 0 012.16 1 5.23 5.23 0 01.7 2.93 5.23 5.23 0 01-.7 2.93A2.44 2.44 0 0119.63 22.13zm0-1.22a1.07 1.07 0 001-.55A3.38 3.38 0 0021 18.85V17.47a3.31 3.31 0 00-.29-1.5 1.23 1.23 0 00-2.06 0 3.31 3.31 0 00-.29 1.5v1.38a3.38 3.38 0 00.29 1.51A1.06 1.06 0 0019.63 20.91zM10.63 22V20.82h2V15.63l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z"
});

var Rewind_1016 = /*#__PURE__*/React.forwardRef(function Rewind_1016(_ref704, ref) {
  var children = _ref704.children,
      rest = _objectWithoutProperties(_ref704, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref705, _ref706, children);
});

var _ref708 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
});

var _ref709 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.64 22.13a2.81 2.81 0 01-1.28-.27 2.36 2.36 0 01-.89-.77A3.39 3.39 0 0117 19.84a7.12 7.12 0 01-.17-1.68A7.24 7.24 0 0117 16.48a3.46 3.46 0 01.52-1.25 2.36 2.36 0 01.89-.77 2.81 2.81 0 011.28-.27 2.44 2.44 0 012.16 1 5.31 5.31 0 01.7 2.93 5.31 5.31 0 01-.7 2.93A2.44 2.44 0 0119.64 22.13zm0-1.22a1 1 0 001-.55 3.24 3.24 0 00.3-1.51V17.47a3.17 3.17 0 00-.3-1.5 1.22 1.22 0 00-2.05 0 3.18 3.18 0 00-.29 1.5v1.38a3.25 3.25 0 00.29 1.51A1 1 0 0019.64 20.91zM12.62 17.42a1.46 1.46 0 001-.27.84.84 0 00.31-.68v-.08a.94.94 0 00-.3-.74 1.2 1.2 0 00-.83-.27 1.65 1.65 0 00-.89.24 2.1 2.1 0 00-.68.68l-.93-.83a5.37 5.37 0 01.44-.51 2.7 2.7 0 01.54-.4 2.55 2.55 0 01.7-.27 3.25 3.25 0 01.87-.1 3.94 3.94 0 011.06.14 2.33 2.33 0 01.82.4 1.91 1.91 0 01.54.63 1.87 1.87 0 01.18.83 2 2 0 01-.11.67 1.82 1.82 0 01-.32.52 1.79 1.79 0 01-.47.36 2.27 2.27 0 01-.57.2V18a2.34 2.34 0 01.63.21 1.7 1.7 0 01.51.38 1.89 1.89 0 01.34.55 2.07 2.07 0 01.12.73 2 2 0 01-.2.92 2 2 0 01-.58.72 2.66 2.66 0 01-.89.45 3.76 3.76 0 01-1.15.16 4.1 4.1 0 01-1-.11A3.1 3.1 0 0111 21.7a2.76 2.76 0 01-.56-.45A4.22 4.22 0 0110 20.7l1.07-.81a3.07 3.07 0 00.28.42 1.94 1.94 0 00.36.34 1.57 1.57 0 00.45.22 2 2 0 00.57.07 1.45 1.45 0 001-.3 1.12 1.12 0 00.34-.85v-.08a1 1 0 00-.37-.8 1.78 1.78 0 00-1.06-.28h-.76V17.42z"
});

var Rewind_3032 = /*#__PURE__*/React.forwardRef(function Rewind_3032(_ref707, ref) {
  var children = _ref707.children,
      rest = _objectWithoutProperties(_ref707, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref708, _ref709, children);
});

var _ref711 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
});

var _ref712 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.64 22.13a2.81 2.81 0 01-1.28-.27 2.36 2.36 0 01-.89-.77A3.39 3.39 0 0117 19.84a7.12 7.12 0 01-.17-1.68A7.24 7.24 0 0117 16.48a3.46 3.46 0 01.52-1.25 2.36 2.36 0 01.89-.77 2.81 2.81 0 011.28-.27 2.44 2.44 0 012.16 1 5.31 5.31 0 01.7 2.93 5.31 5.31 0 01-.7 2.93A2.44 2.44 0 0119.64 22.13zm0-1.22a1 1 0 001-.55 3.24 3.24 0 00.3-1.51V17.47a3.17 3.17 0 00-.3-1.5 1.22 1.22 0 00-2.05 0 3.18 3.18 0 00-.29 1.5v1.38a3.25 3.25 0 00.29 1.51A1 1 0 0019.64 20.91zM12.62 17.42a1.46 1.46 0 001-.27.84.84 0 00.31-.68v-.08a.94.94 0 00-.3-.74 1.2 1.2 0 00-.83-.27 1.65 1.65 0 00-.89.24 2.1 2.1 0 00-.68.68l-.93-.83a5.37 5.37 0 01.44-.51 2.7 2.7 0 01.54-.4 2.55 2.55 0 01.7-.27 3.25 3.25 0 01.87-.1 3.94 3.94 0 011.06.14 2.33 2.33 0 01.82.4 1.91 1.91 0 01.54.63 1.87 1.87 0 01.18.83 2 2 0 01-.11.67 1.82 1.82 0 01-.32.52 1.79 1.79 0 01-.47.36 2.27 2.27 0 01-.57.2V18a2.34 2.34 0 01.63.21 1.7 1.7 0 01.51.38 1.89 1.89 0 01.34.55 2.07 2.07 0 01.12.73 2 2 0 01-.2.92 2 2 0 01-.58.72 2.66 2.66 0 01-.89.45 3.76 3.76 0 01-1.15.16 4.1 4.1 0 01-1-.11A3.1 3.1 0 0111 21.7a2.76 2.76 0 01-.56-.45A4.22 4.22 0 0110 20.7l1.07-.81a3.07 3.07 0 00.28.42 1.94 1.94 0 00.36.34 1.57 1.57 0 00.45.22 2 2 0 00.57.07 1.45 1.45 0 001-.3 1.12 1.12 0 00.34-.85v-.08a1 1 0 00-.37-.8 1.78 1.78 0 00-1.06-.28h-.76V17.42z"
});

var Rewind_3024 = /*#__PURE__*/React.forwardRef(function Rewind_3024(_ref710, ref) {
  var children = _ref710.children,
      rest = _objectWithoutProperties(_ref710, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref711, _ref712, children);
});

var _ref714 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
});

var _ref715 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.64 22.13a2.81 2.81 0 01-1.28-.27 2.36 2.36 0 01-.89-.77A3.39 3.39 0 0117 19.84a7.12 7.12 0 01-.17-1.68A7.24 7.24 0 0117 16.48a3.46 3.46 0 01.52-1.25 2.36 2.36 0 01.89-.77 2.81 2.81 0 011.28-.27 2.44 2.44 0 012.16 1 5.31 5.31 0 01.7 2.93 5.31 5.31 0 01-.7 2.93A2.44 2.44 0 0119.64 22.13zm0-1.22a1 1 0 001-.55 3.24 3.24 0 00.3-1.51V17.47a3.17 3.17 0 00-.3-1.5 1.22 1.22 0 00-2.05 0 3.18 3.18 0 00-.29 1.5v1.38a3.25 3.25 0 00.29 1.51A1 1 0 0019.64 20.91zM12.62 17.42a1.46 1.46 0 001-.27.84.84 0 00.31-.68v-.08a.94.94 0 00-.3-.74 1.2 1.2 0 00-.83-.27 1.65 1.65 0 00-.89.24 2.1 2.1 0 00-.68.68l-.93-.83a5.37 5.37 0 01.44-.51 2.7 2.7 0 01.54-.4 2.55 2.55 0 01.7-.27 3.25 3.25 0 01.87-.1 3.94 3.94 0 011.06.14 2.33 2.33 0 01.82.4 1.91 1.91 0 01.54.63 1.87 1.87 0 01.18.83 2 2 0 01-.11.67 1.82 1.82 0 01-.32.52 1.79 1.79 0 01-.47.36 2.27 2.27 0 01-.57.2V18a2.34 2.34 0 01.63.21 1.7 1.7 0 01.51.38 1.89 1.89 0 01.34.55 2.07 2.07 0 01.12.73 2 2 0 01-.2.92 2 2 0 01-.58.72 2.66 2.66 0 01-.89.45 3.76 3.76 0 01-1.15.16 4.1 4.1 0 01-1-.11A3.1 3.1 0 0111 21.7a2.76 2.76 0 01-.56-.45A4.22 4.22 0 0110 20.7l1.07-.81a3.07 3.07 0 00.28.42 1.94 1.94 0 00.36.34 1.57 1.57 0 00.45.22 2 2 0 00.57.07 1.45 1.45 0 001-.3 1.12 1.12 0 00.34-.85v-.08a1 1 0 00-.37-.8 1.78 1.78 0 00-1.06-.28h-.76V17.42z"
});

var Rewind_3020 = /*#__PURE__*/React.forwardRef(function Rewind_3020(_ref713, ref) {
  var children = _ref713.children,
      rest = _objectWithoutProperties(_ref713, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref714, _ref715, children);
});

var _ref717 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
});

var _ref718 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.64 22.13a2.81 2.81 0 01-1.28-.27 2.36 2.36 0 01-.89-.77A3.39 3.39 0 0117 19.84a7.12 7.12 0 01-.17-1.68A7.24 7.24 0 0117 16.48a3.46 3.46 0 01.52-1.25 2.36 2.36 0 01.89-.77 2.81 2.81 0 011.28-.27 2.44 2.44 0 012.16 1 5.31 5.31 0 01.7 2.93 5.31 5.31 0 01-.7 2.93A2.44 2.44 0 0119.64 22.13zm0-1.22a1 1 0 001-.55 3.24 3.24 0 00.3-1.51V17.47a3.17 3.17 0 00-.3-1.5 1.22 1.22 0 00-2.05 0 3.18 3.18 0 00-.29 1.5v1.38a3.25 3.25 0 00.29 1.51A1 1 0 0019.64 20.91zM12.62 17.42a1.46 1.46 0 001-.27.84.84 0 00.31-.68v-.08a.94.94 0 00-.3-.74 1.2 1.2 0 00-.83-.27 1.65 1.65 0 00-.89.24 2.1 2.1 0 00-.68.68l-.93-.83a5.37 5.37 0 01.44-.51 2.7 2.7 0 01.54-.4 2.55 2.55 0 01.7-.27 3.25 3.25 0 01.87-.1 3.94 3.94 0 011.06.14 2.33 2.33 0 01.82.4 1.91 1.91 0 01.54.63 1.87 1.87 0 01.18.83 2 2 0 01-.11.67 1.82 1.82 0 01-.32.52 1.79 1.79 0 01-.47.36 2.27 2.27 0 01-.57.2V18a2.34 2.34 0 01.63.21 1.7 1.7 0 01.51.38 1.89 1.89 0 01.34.55 2.07 2.07 0 01.12.73 2 2 0 01-.2.92 2 2 0 01-.58.72 2.66 2.66 0 01-.89.45 3.76 3.76 0 01-1.15.16 4.1 4.1 0 01-1-.11A3.1 3.1 0 0111 21.7a2.76 2.76 0 01-.56-.45A4.22 4.22 0 0110 20.7l1.07-.81a3.07 3.07 0 00.28.42 1.94 1.94 0 00.36.34 1.57 1.57 0 00.45.22 2 2 0 00.57.07 1.45 1.45 0 001-.3 1.12 1.12 0 00.34-.85v-.08a1 1 0 00-.37-.8 1.78 1.78 0 00-1.06-.28h-.76V17.42z"
});

var Rewind_3016 = /*#__PURE__*/React.forwardRef(function Rewind_3016(_ref716, ref) {
  var children = _ref716.children,
      rest = _objectWithoutProperties(_ref716, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref717, _ref718, children);
});

var _ref720 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
});

var _ref721 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z"
});

var Rewind_532 = /*#__PURE__*/React.forwardRef(function Rewind_532(_ref719, ref) {
  var children = _ref719.children,
      rest = _objectWithoutProperties(_ref719, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref720, _ref721, children);
});

var _ref723 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
});

var _ref724 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z"
});

var Rewind_524 = /*#__PURE__*/React.forwardRef(function Rewind_524(_ref722, ref) {
  var children = _ref722.children,
      rest = _objectWithoutProperties(_ref722, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref723, _ref724, children);
});

var _ref726 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
});

var _ref727 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z"
});

var Rewind_520 = /*#__PURE__*/React.forwardRef(function Rewind_520(_ref725, ref) {
  var children = _ref725.children,
      rest = _objectWithoutProperties(_ref725, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref726, _ref727, children);
});

var _ref729 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
});

var _ref730 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z"
});

var Rewind_516 = /*#__PURE__*/React.forwardRef(function Rewind_516(_ref728, ref) {
  var children = _ref728.children,
      rest = _objectWithoutProperties(_ref728, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref729, _ref730, children);
});

var _ref732 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 30H4a2.0023 2.0023 0 01-2-2V24a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0112 30zM4 24v4h8V24zM28 20H12a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 20zM12 14v4H28V14zM16 10H4A2.0023 2.0023 0 012 8V4A2.0023 2.0023 0 014 2H16a2.0023 2.0023 0 012 2V8A2.0023 2.0023 0 0116 10zM4 4V8H16V4z"
});

var Roadmap32 = /*#__PURE__*/React.forwardRef(function Roadmap32(_ref731, ref) {
  var children = _ref731.children,
      rest = _objectWithoutProperties(_ref731, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref732, children);
});

var _ref734 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 30H4a2.0023 2.0023 0 01-2-2V24a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0112 30zM4 24v4h8V24zM28 20H12a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 20zM12 14v4H28V14zM16 10H4A2.0023 2.0023 0 012 8V4A2.0023 2.0023 0 014 2H16a2.0023 2.0023 0 012 2V8A2.0023 2.0023 0 0116 10zM4 4V8H16V4z"
});

var Roadmap24 = /*#__PURE__*/React.forwardRef(function Roadmap24(_ref733, ref) {
  var children = _ref733.children,
      rest = _objectWithoutProperties(_ref733, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref734, children);
});

var _ref736 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 30H4a2.0023 2.0023 0 01-2-2V24a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0112 30zM4 24v4h8V24zM28 20H12a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 20zM12 14v4H28V14zM16 10H4A2.0023 2.0023 0 012 8V4A2.0023 2.0023 0 014 2H16a2.0023 2.0023 0 012 2V8A2.0023 2.0023 0 0116 10zM4 4V8H16V4z"
});

var Roadmap20 = /*#__PURE__*/React.forwardRef(function Roadmap20(_ref735, ref) {
  var children = _ref735.children,
      rest = _objectWithoutProperties(_ref735, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref736, children);
});

var _ref738 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 30H4a2.0023 2.0023 0 01-2-2V24a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0112 30zM4 24v4h8V24zM28 20H12a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 20zM12 14v4H28V14zM16 10H4A2.0023 2.0023 0 012 8V4A2.0023 2.0023 0 014 2H16a2.0023 2.0023 0 012 2V8A2.0023 2.0023 0 0116 10zM4 4V8H16V4z"
});

var Roadmap16 = /*#__PURE__*/React.forwardRef(function Roadmap16(_ref737, ref) {
  var children = _ref737.children,
      rest = _objectWithoutProperties(_ref737, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref738, children);
});

export { Police16, Police20, Police24, Police32, Policy16, Policy20, Policy24, Policy32, Popup16, Popup20, Popup24, Popup32, Portfolio16, Portfolio20, Portfolio24, Portfolio32, Power16, Power20, Power24, Power32, Ppt16, Ppt20, Ppt24, Ppt32, PresentationFile16, PresentationFile20, PresentationFile24, PresentationFile32, Pressure16, Pressure20, Pressure24, Pressure32, PressureFilled16, PressureFilled20, PressureFilled24, PressureFilled32, PreviousFilled16, PreviousFilled20, PreviousFilled24, PreviousFilled32, PreviousOutline16, PreviousOutline20, PreviousOutline24, PreviousOutline32, Printer16, Printer20, Printer24, Printer32, Product16, Product20, Product24, Product32, Purchase16, Purchase20, Purchase24, Purchase32, QqPlot16, QqPlot20, QqPlot24, QqPlot32, QrCode16, QrCode20, QrCode24, QrCode32, QueryQueue16, QueryQueue20, QueryQueue24, QueryQueue32, Queued16, Queued20, Queued24, Queued32, Quotes16, Quotes20, Quotes24, Quotes32, Radio16, Radio20, Radio24, Radio32, RadioButton16, RadioButton20, RadioButton24, RadioButton32, RadioButtonChecked16, RadioButtonChecked20, RadioButtonChecked24, RadioButtonChecked32, Rain16, Rain20, Rain24, Rain32, RainDrizzle16, RainDrizzle20, RainDrizzle24, RainDrizzle32, RainDrop16, RainDrop20, RainDrop24, RainDrop32, RainHeavy16, RainHeavy20, RainHeavy24, RainHeavy32, RainScattered16, RainScattered20, RainScattered24, RainScattered32, RainScatteredNight16, RainScatteredNight20, RainScatteredNight24, RainScatteredNight32, Raw16, Raw20, Raw24, Raw32, Receipt16, Receipt20, Receipt24, Receipt32, RecentlyViewed16, RecentlyViewed20, RecentlyViewed24, RecentlyViewed32, Recommend16, Recommend20, Recommend24, Recommend32, Recording16, Recording20, Recording24, Recording32, RecordingFilled16, RecordingFilled20, RecordingFilled24, RecordingFilled32, RecordingFilledAlt16, RecordingFilledAlt20, RecordingFilledAlt24, RecordingFilledAlt32, Redo16, Redo20, Redo24, Redo32, ReflectHorizontal16, ReflectHorizontal20, ReflectHorizontal24, ReflectHorizontal32, ReflectVertical16, ReflectVertical20, ReflectVertical24, ReflectVertical32, Reminder16, Reminder20, Reminder24, Reminder32, ReminderMedical16, ReminderMedical20, ReminderMedical24, ReminderMedical32, Renew16, Renew20, Renew24, Renew32, Repeat16, Repeat20, Repeat24, Repeat32, RepeatOne16, RepeatOne20, RepeatOne24, RepeatOne32, Reply16, Reply20, Reply24, Reply32, Report16, Report20, Report24, Report32, ReportData16, ReportData20, ReportData24, ReportData32, RequestQuote16, RequestQuote20, RequestQuote24, RequestQuote32, ResearchBlochSphere16, ResearchBlochSphere20, ResearchBlochSphere24, ResearchBlochSphere32, ResearchHintonPlot16, ResearchHintonPlot20, ResearchHintonPlot24, ResearchHintonPlot32, ResearchMatrix16, ResearchMatrix20, ResearchMatrix24, ResearchMatrix32, Reset16, Reset20, Reset24, Reset32, ResetAlt16, ResetAlt20, ResetAlt24, ResetAlt32, Restart16, Restart20, Restart24, Restart32, Restaurant16, Restaurant20, Restaurant24, Restaurant32, RestaurantFine16, RestaurantFine20, RestaurantFine24, RestaurantFine32, Rewind_1016, Rewind_1020, Rewind_1024, Rewind_1032, Rewind_3016, Rewind_3020, Rewind_3024, Rewind_3032, Rewind_516, Rewind_520, Rewind_524, Rewind_532, Roadmap16, Roadmap20, Roadmap24, Roadmap32, WatsonHealthPointerText16, WatsonHealthPointerText20, WatsonHealthRegionAnalysisArea16, WatsonHealthRegionAnalysisArea20, WatsonHealthRegionAnalysisArea24, WatsonHealthRegionAnalysisArea32, WatsonHealthRegionAnalysisVolume16, WatsonHealthRegionAnalysisVolume20, WatsonHealthRegionAnalysisVolume24, WatsonHealthRegionAnalysisVolume32, WatsonHealthRegistration16, WatsonHealthRegistration20, WatsonHealthRegistration24, WatsonHealthRegistration32 };
